import {
  ActionBundleReviewSchema,
  type AgentExecutionMode,
  AgentRunAcceptedSchema,
  type AssignStaffRequestRequest,
  AssignStaffRequestRequestSchema,
  type AtomicAcceptanceRequest,
  type CancelLabOrderRequest,
  type CancelPrintablePrescriptionRequest,
  CancelPrintablePrescriptionRequestSchema,
  ChartAssistantCapabilitiesSchema,
  type ClinicDocumentFillSuggestionsCommand,
  ClinicDocumentFillSuggestionsCommandSchema,
  ClinicDocumentFillSuggestionsResponseSchema,
  ClinicImagingStudyConceptListSchema,
  ClinicPhysiciansResponseSchema,
  type ClinicReferralPolicy,
  ClinicReferralPolicySchema,
  type CreateEncounterFollowUpTaskRequest,
  CreateEncounterFollowUpTaskRequestSchema,
  type CreateFdbCanadaDemoWorkflowRequest,
  CreateFdbCanadaDemoWorkflowRequestSchema,
  type CreatePatientStaffRequestRequest,
  CreatePatientStaffRequestRequestSchema,
  type CreateStaffRequestRequest,
  CreateStaffRequestRequestSchema,
  type DictationBackup,
  DictationBackupDeleteReceiptSchema,
  type DictationBackupReceipt,
  DictationBackupReceiptSchema,
  DictationBackupSchema,
  type DiscardLabOrderDraftRequest,
  type DraftReviewFeedback,
  DraftReviewFeedbackReceiptSchema,
  EmrPageChartImportReceiptSchema,
  type EmrPageChartImportRequest,
  EmrPageChartImportRequestSchema,
  EmrPageImportSettingSchema,
  type EncounterAssistantInterpretRequest,
  EncounterAssistantInterpretRequestSchema,
  EncounterAssistantInterpretResponseSchema,
  type EncounterAssistantTranscribeRequest,
  EncounterAssistantTranscribeRequestSchema,
  EncounterContextSchema,
  type EncounterDiscussionContextCheckRequest,
  EncounterDiscussionContextCheckRequestSchema,
  EncounterDiscussionContextCheckResponseSchema,
  type EncounterDiscussionRequest,
  EncounterDiscussionRequestSchema,
  EncounterDiscussionResponseSchema,
  EncounterFollowUpTaskSchema,
  EncounterFollowUpTasksSchema,
  type EncounterNoteAddenda,
  EncounterNoteAddendaSchema,
  type EncounterReferralDraftRequest,
  EncounterReferralDraftRequestSchema,
  EncounterReferralDraftResponseSchema,
  EncounterReferralDraftSummarySchema,
  EncounterReferralSummarySchema,
  FdbAllergenSearchResponseSchema,
  type FdbCanadaDemoOrder,
  FdbCanadaDemoWorkflowSchema,
  FdbCanadaEvaluationLookupResponseSchema,
  FdbInteractionMonographSchema,
  FdbMedicationSearchResponseSchema,
  type FdbScreeningRequest,
  FdbScreeningRequestSchema,
  FdbScreeningSchema,
  type FormProposalLabel,
  FormProposalLabelSchema,
  ImagingOrderConfigurationSchema,
  ImagingOrderDraftPreviewSchema,
  ImagingRequisitionManifestPreviewSchema,
  LAB_TEST_CATALOGUE,
  type LabOrderCancellationReceipt,
  LabOrderCancellationReceiptSchema,
  LabOrderConfigurationSchema,
  type LabOrderDraft,
  type LabOrderDraftContentPreview,
  LabOrderDraftContentPreviewSchema,
  type LabOrderDraftDocument,
  LabOrderDraftDocumentSchema,
  type LabOrderDraftEnvelope,
  LabOrderDraftEnvelopeSchema,
  LabOrderDraftSchema,
  type LabOrderDraftSetPreview,
  LabOrderDraftSetPreviewSchema,
  LabOrderProfileSchema,
  type LabOrderSignReceipt,
  LabOrderSignReceiptSchema,
  LabRequisitionManifestPreviewSchema,
  type LetterRenderRequest,
  LetterRenderRequestSchema,
  LetterRenderResponseSchema,
  LocalAcceptanceReceiptSchema,
  MedicationRefillCandidatesSchema,
  type ModelRunDescriptor,
  type NoteWorkingDraft,
  type NoteWorkingDraftDeleteReceipt,
  NoteWorkingDraftDeleteReceiptSchema,
  type NoteWorkingDraftReceipt,
  NoteWorkingDraftReceiptSchema,
  NoteWorkingDraftSchema,
  type OrderResultTransitionRequest,
  OrderResultTransitionRequestSchema,
  OrderResultWorkflowSchema,
  OrderResultWorkQueueSchema,
  PatientCareWorkSchema,
  type PatientChartQuestionRequest,
  PatientChartQuestionRequestSchema,
  PatientChartQuestionResponseSchema,
  type PatientEducationDraft,
  PatientEducationDraftEnvelopeSchema,
  PatientEducationDraftSchema,
  type PatientEducationDraftTransition,
  PatientLabResultsSchema,
  PatientLabTrendsSchema,
  PatientLegacyVisitsSchema,
  PatientPhysicianUpdateReceiptSchema,
  type PatientProfileAssistantInterpretRequest,
  PatientProfileAssistantInterpretRequestSchema,
  PatientProfileAssistantInterpretResponseSchema,
  type PatientProfileAssistantTranscribeRequest,
  PatientProfileAssistantTranscribeRequestSchema,
  PatientProfileAssistantTranscribeResponseSchema,
  PatientReferralArtifactSummarySchema,
  PersistedImagingOrderSchema,
  PersistedLabOrderSchema,
  PreparedFormEntrySchema,
  PreparedFormNoticesSchema,
  PreparedFormsIncompleteSchema,
  PreparedImagingOrderSchema,
  PreparedLabOrderSchema,
  type PreparedManualOrder,
  PreparedManualOrderSchema,
  type PrepareImagingOrderRequest,
  type PrepareLabOrderDraftRequest,
  type PrepareLabOrderRequest,
  type PreviewImagingOrderRequest,
  type PreviewLabOrderDraftContentRequest,
  type PreviewLabOrderDraftRequest,
  PrintablePrescriptionCancellationSchema,
  type ProposedEncounterImagingOrder,
  type ProposedEncounterLabOrder,
  type ProposedEncounterReferral,
  type ReferralDirectoryEntryInput,
  ReferralDirectoryEntrySchema,
  ReferralEnclosureCandidateSchema,
  ReferralHandoffDefaultSchema,
  type RolloutPolicyReference,
  RolloutPolicyReferenceSchema,
  type RolloutScope,
  type SaveClinicReferralPolicyRequest,
  SaveClinicReferralPolicyRequestSchema,
  type SaveDictationBackupRequest,
  SaveDictationBackupRequestSchema,
  type SaveLabOrderProfileInput,
  SaveLabOrderProfileInputSchema,
  type SaveNoteWorkingDraftRequest,
  SaveNoteWorkingDraftRequestSchema,
  type SavePatientEducationDraftRequest,
  SaveReferralDirectoryEntryRequestSchema,
  type SaveReferralHandoffDefaultRequest,
  SaveReferralHandoffDefaultRequestSchema,
  SetEmrPageImportSettingRequestSchema,
  type SignEncounterNoteAddendumReceipt,
  SignEncounterNoteAddendumReceiptSchema,
  type SignEncounterNoteAddendumRequest,
  SignEncounterNoteAddendumRequestSchema,
  type SignLabOrderDraftRequest,
  SiteStaffListSchema,
  StaffRequestSchema,
  StaffRequestsSchema,
  type TransitionFdbCanadaDemoWorkflowRequest,
  TransitionFdbCanadaDemoWorkflowRequestSchema,
  type TransitionStaffRequestRequest,
  TransitionStaffRequestRequestSchema,
  type UpdateFdbCanadaDemoWorkflowRequest,
  UpdateFdbCanadaDemoWorkflowRequestSchema,
  type UpdatePatientPhysicianRequest,
  UpdatePatientPhysicianRequestSchema,
  type UpsertLabOrderDraftRequest,
  type VisitContextRequestOptions,
  VisitContextRequestOptionsSchema,
  VisitContextSchema,
  VisitSourceContentSchema,
  type VisitSourceRef,
  VisitSourceRefSchema,
  WalkInPatientMatchesSchema,
  WalkInPatientSearchQuerySchema,
} from "@emr/contracts";
import { z } from "zod";
import { type FormProposedTest, formProposedTestIdentity } from "../lib/formOrderProposals";
import {
  type AssignAppointmentRoomRequest,
  AssignAppointmentRoomRequestSchema,
  BoardQueueRowSchema,
  ChartRecordReceiptSchema,
  ClinicalWriteConflictError,
  ClinicRoomSchema,
  ClinicRoomsSchema,
  type CreateClinicRoomRequest,
  CreateClinicRoomRequestSchema,
  type CreateWalkInRequest,
  CreateWalkInRequestSchema,
  type CreateWorkforceInvitationRequest,
  CreateWorkforceInvitationRequestSchema,
  type DeleteClinicRoomRequest,
  DeleteClinicRoomRequestSchema,
  DeletedClinicRoomSchema,
  DuplicatePatientMatchesSchema,
  type DuplicatePatientProbe,
  DuplicatePatientProbeRequestSchema,
  EncounterNoteWriteReceiptSchema,
  type EncounterNoteWriteRequest,
  EncounterNoteWriteRequestSchema,
  type PatientDemographicsUpdateInput,
  PatientDemographicsUpdateReceiptSchema,
  PatientDirectorySchema,
  PatientEncounterHistorySchema,
  PatientProfileSchema,
  PatientProfileSummarySchema,
  type PatientProfileUpdateInput,
  PatientProfileUpdateReceiptSchema,
  PatientSignedNotesSchema,
  PatientWorkspaceSchema,
  PrescriptionChangeReceiptSchema,
  PrescriptionRenewalReceiptSchema,
  PrintablePrescriptionListSchema,
  PrintablePrescriptionRecordSchema,
  type PrintablePrescriptionRequest,
  PrintablePrescriptionRequestSchema,
  type RecordPatientAllergyInput,
  RecordPatientAllergyInputSchema,
  type RecordPatientMedicationInput,
  RecordPatientMedicationInputSchema,
  type RecordPatientProblemInput,
  RecordPatientProblemInputSchema,
  RegisterPatientReceiptSchema,
  type RegisterPatientRequest,
  RegisterPatientRequestSchema,
  type ReleaseAppointmentRoomRequest,
  ReleaseAppointmentRoomRequestSchema,
  SaveEncounterDiagnosesReceiptSchema,
  type SaveEncounterDiagnosesRequest,
  SaveEncounterDiagnosesRequestSchema,
  SiteContactSchema,
  type StartPatientEncounterRequest,
  StartPatientEncounterRequestSchema,
  StartPatientEncounterResultSchema,
  TodayBoardMetricsSchema,
  TodayBoardSchema,
  type UpdateClinicRoomRequest,
  UpdateClinicRoomRequestSchema,
  type UpdateSiteContactRequest,
  UpdateSiteContactRequestSchema,
  type UpdateWorkforceProfileRequest,
  UpdateWorkforceProfileRequestSchema,
  unwrapRpcResult,
  WalkInIntakeResultSchema,
  WorkforceInvitationOutcomeSchema,
  WorkforceInvitationSchema,
  WorkforceMemberSchema,
  WorkforceMembershipStatusOutcomeSchema,
  WorkforceProfileSchema,
} from "./clinicalWorkspace";
import { createClinicConversationsClient } from "./clinicConversations";
import { createFaxesClient } from "./faxes";
import { createHealthCardPhotosClient } from "./healthCardPhotos";
import { createIncomingDocumentsClient } from "./incomingDocuments";
import { manualOrderRefusal } from "./manualOrders";
import { createPatientConsentsClient } from "./patientConsents";
import { createPatientDocumentDeliveriesClient } from "./patientDocumentDeliveries";
import { createPatientDocumentsClient } from "./patientDocuments";
import { createPatientMessagingClient } from "./patientMessaging";
import { createPatientMessagingSettingsClient } from "./patientMessagingSettings";
import { ReferralDirectorySearchResultSchema, SpecialtyCodeSchema } from "./referralDirectory";
import {
  type ReferralTransitionRequest,
  ReferralTransitionRequestSchema,
  ReferralWorkflowSchema,
  ReferralWorkQueueSchema,
} from "./referrals";
import { createSchedulingIntakeClient } from "./schedulingIntake";

export interface AgentRunRequestDto {
  readonly encounterId: string;
  readonly expectedEncounterVersion: number;
  readonly intent: "synthesize_plan" | "draft_referral" | "draft_orders" | "draft_discharge";
  readonly purposeOfUse: "treatment" | "payment" | "operations";
  readonly idempotencyKey: string;
  readonly orderKind?: "laboratory" | "imaging";
  readonly proposedLabOrder?: ProposedEncounterLabOrder;
  readonly proposedImagingOrder?: ProposedEncounterImagingOrder;
  readonly proposedReferral?: ProposedEncounterReferral;
  readonly requestedRoute?: "auto" | "fast" | "deep";
}

export interface AgentRunAcceptedDto {
  readonly runId: string;
  readonly eventsUrl: string;
  readonly routing: ModelRunDescriptor;
  readonly mode: AgentExecutionMode;
  readonly rolloutPolicy: RolloutPolicyReference;
}

export interface AgentStreamEvent {
  readonly id: number;
  readonly type: string;
  readonly data: unknown;
}

export interface AgentClientOptions {
  readonly baseUrl: string;
  readonly getAccessToken: () => Promise<string>;
  /** Selected workforce site, resolved server-side against the AAL2 session. */
  readonly siteId?: string;
  readonly fetch?: typeof fetch;
}

function parseAccepted(value: unknown): AgentRunAcceptedDto {
  const parsed = AgentRunAcceptedSchema.safeParse(value);
  if (!parsed.success) throw new Error("Agent API returned an invalid run receipt");
  return parsed.data;
}

function sameOriginUrl(baseUrl: string, path: string): string {
  const pageOrigin = globalThis.location?.origin ?? "http://127.0.0.1";
  const base = new URL(baseUrl, pageOrigin);
  const resolved = new URL(path, base);
  if (resolved.origin !== base.origin) {
    throw new Error("Agent event stream must stay on the configured API origin");
  }
  return resolved.toString();
}

/**
 * The §11.2 approval gate refused: the chart changed materially after the
 * draft was grounded. Carries the server's instruction verbatim so the
 * surface can tell the physician exactly what to do (refresh + re-review).
 */
export class ClinicalContextStaleError extends Error {
  public readonly code = "CONTEXT_STALE";
}

/** A pre-accept refusal: the clinic selected a form the physician has not reviewed. */
export class ClinicalLabFormChangedError extends ClinicalWriteConflictError {}

/**
 * A note working draft save refused because the visit is signed or cancelled (POLICY_BLOCKED,
 * 55000), as opposed to a draft saved from another tab or device (CONFLICT, PT409). Both are
 * HTTP 409, and both are ClinicalWriteConflictError; check this one first.
 */
export class NoteWorkingDraftClosedError extends ClinicalWriteConflictError {}

/** Browsers cap the bodies of in-flight keepalive requests at 64 KiB in total. */
const NOTE_WORKING_DRAFT_KEEPALIVE_MAX_BYTES = 60_000;

async function noteWorkingDraftRefusal(
  response: Response,
  conflictMessage: string,
  fallback: string,
): Promise<Error> {
  if (response.status !== 409) return blockedClinicalRequest(response, fallback);
  const body = (await response.json().catch(() => null)) as {
    error?: { code?: unknown };
  } | null;
  return body?.error?.code === "POLICY_BLOCKED"
    ? new NoteWorkingDraftClosedError(
        "This visit is signed or closed, so its note draft is no longer saved.",
      )
    : new ClinicalWriteConflictError(conflictMessage);
}

/**
 * A signing refused with 409: the key already signed different text (CONFLICT, PT409), which
 * means an earlier attempt from the same dialog reached the chart, or the note is not signed
 * (POLICY_BLOCKED, 55000).
 */
async function noteAddendumRefusal(response: Response): Promise<Error> {
  if (response.status !== 409) {
    return blockedClinicalRequest(response, "The addendum could not be signed. Try again.");
  }
  const body = (await response.json().catch(() => null)) as {
    error?: { code?: unknown };
  } | null;
  return body?.error?.code === "POLICY_BLOCKED"
    ? new ClinicalRequestError("This note is not signed, so it cannot take an addendum.", 409)
    : new ClinicalWriteConflictError(
        "An addendum from this window was already signed. Close it to see that addendum, then add another if needed.",
      );
}

/** What a suggested test is called when nothing on file names it. */
export const UNNAMED_FORM_PROPOSAL = "A suggested test";

/**
 * The plain name of a test clinic instructions suggest: the reviewed label, the reviewed
 * catalogue test, or the lab catalogue's name. Never the code itself; UNNAMED_FORM_PROPOSAL
 * when none of them names it.
 */
export function formProposalName(
  conceptId: string,
  proposedTests: readonly FormProposedTest[] = [],
  proposalLabels: readonly FormProposalLabel[] = [],
): string {
  return (
    proposalLabels.find((entry) => entry.conceptId === conceptId)?.label ??
    proposedTests.find((test) => formProposedTestIdentity(test) === conceptId)?.display ??
    LAB_TEST_CATALOGUE.find((entry) => entry.loinc !== null && conceptId === `LOINC|${entry.loinc}`)
      ?.display ??
    UNNAMED_FORM_PROPOSAL
  );
}

/** Whether the physician can tell which test this suggestion is. */
export function formProposalIsNamed(
  conceptId: string,
  proposedTests: readonly FormProposedTest[] = [],
  proposalLabels: readonly FormProposalLabel[] = [],
): boolean {
  return formProposalName(conceptId, proposedTests, proposalLabels) !== UNNAMED_FORM_PROPOSAL;
}

/**
 * The suggested tests as one plain list: each named test once, then how many have no name on
 * file, so several unnamed suggestions never read as one.
 */
export function formProposalNames(
  conceptIds: readonly string[],
  proposedTests: readonly FormProposedTest[] = [],
  proposalLabels: readonly FormProposalLabel[] = [],
): string {
  const ids = [...new Set(conceptIds)];
  const named = [
    ...new Set(
      ids
        .filter((id) => formProposalIsNamed(id, proposedTests, proposalLabels))
        .map((id) => formProposalName(id, proposedTests, proposalLabels)),
    ),
  ];
  const unnamed = ids.filter((id) => !formProposalIsNamed(id, proposedTests, proposalLabels));
  return [
    ...named,
    ...(unnamed.length === 0
      ? []
      : [
          unnamed.length === 1
            ? "one test with no name on file"
            : `${unnamed.length} tests with no name on file`,
        ]),
  ].join(", ");
}

export class ClinicalFormOrderProposalsError extends Error {
  constructor(
    readonly proposedConceptIds: readonly string[],
    readonly proposedTests: readonly FormProposedTest[] = [],
    readonly proposalLabels: readonly FormProposalLabel[] = [],
  ) {
    super(
      `Clinic instructions suggest more tests for these forms: ${formProposalNames(proposedConceptIds, proposedTests, proposalLabels)}. Review and add the ones you want to order, or continue without them.`,
    );
    this.name = "ClinicalFormOrderProposalsError";
  }
}

/**
 * A test the physician chose not to order is on the order after all (for example, the order's
 * tests changed). The choice is forgotten and the forms are prepared again.
 */
export class ClinicalDeclinedTestOnOrderError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ClinicalDeclinedTestOnOrderError";
  }
}

/**
 * The draft preview of the whole form set is not available: a server without it, a vault that
 * cannot render it, or forms only the governed preparation can choose. The caller prepares the
 * forms for signing instead, as it did before the preview existed.
 */
export class ClinicalLabPreviewUnavailableError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ClinicalLabPreviewUnavailableError";
  }
}

/** The whole-set draft preview with its PDF decoded. */
export type LabOrderDraftSetPreviewResult = Omit<LabOrderDraftSetPreview, "pdfBase64"> & {
  readonly bytes: Uint8Array;
};

/** Reads the typed refusal for a declined test that is on the order; else null. */
async function declinedTestOnOrderRefusal(
  response: Response,
): Promise<ClinicalDeclinedTestOnOrderError | null> {
  if (response.status !== 422 && response.status !== 409) return null;
  const body = (await response
    .clone()
    .json()
    .catch(() => null)) as { error?: { detail?: unknown; message?: unknown } } | null;
  if (body?.error?.detail !== "declined_test_on_order") return null;
  return new ClinicalDeclinedTestOnOrderError(
    typeof body.error.message === "string" && body.error.message.trim().length > 0
      ? body.error.message
      : "A test on this order is also marked as not ordered. Prepare the forms again.",
  );
}

/** Reads a 409 that lists suggested tests into ClinicalFormOrderProposalsError; else null. */
async function formOrderProposalsRefusal(
  response: Response,
): Promise<ClinicalFormOrderProposalsError | null> {
  if (response.status !== 409) return null;
  const body = (await response
    .clone()
    .json()
    .catch(() => null)) as {
    error?: {
      detail?: string;
      details?: { proposedConceptIds?: unknown; proposedTests?: unknown; proposalLabels?: unknown };
    };
  } | null;
  const proposed = body?.error?.details?.proposedConceptIds;
  if (
    body?.error?.detail !== "form_instruction_order_proposals" ||
    !Array.isArray(proposed) ||
    !proposed.every((id): id is string => typeof id === "string")
  )
    return null;
  const tests = z
    .array(
      z.object({
        codeSystem: z.enum(["LOINC", "local", "RadLex"]),
        code: z.string().trim().min(1),
        display: z.string().trim().min(1),
      }),
    )
    .safeParse(body.error.details?.proposedTests ?? []);
  const labels = z
    .array(FormProposalLabelSchema)
    .safeParse(body.error.details?.proposalLabels ?? []);
  return new ClinicalFormOrderProposalsError(
    proposed,
    tests.success
      ? tests.data.filter((test) => proposed.includes(formProposedTestIdentity(test)))
      : [],
    labels.success ? labels.data.filter((entry) => proposed.includes(entry.conceptId)) : [],
  );
}

/**
 * A 409 the server refused on clinic policy, in the server's own words ("No lab requisition is in
 * use at this clinic…", say). What to do is in the message; the generic
 * "workflow changed" reading of a 409 would hide it.
 */
async function policyBlockedRefusal(response: Response): Promise<ClinicalRequestError | null> {
  if (response.status !== 409) return null;
  const body = (await response
    .clone()
    .json()
    .catch(() => null)) as {
    readonly error?: { readonly code?: unknown; readonly message?: unknown };
  } | null;
  const message = body?.error?.message;
  return body?.error?.code === "POLICY_BLOCKED" &&
    typeof message === "string" &&
    message.trim().length > 0
    ? new ClinicalRequestError(message, response.status)
    : null;
}

async function contextStaleRefusal(response: Response): Promise<ClinicalContextStaleError | null> {
  if (response.status !== 409) return null;
  const body = (await response
    .clone()
    .json()
    .catch(() => null)) as {
    readonly error?: { readonly code?: unknown; readonly message?: unknown };
  } | null;
  return body?.error?.code === "CONTEXT_STALE" && typeof body.error.message === "string"
    ? new ClinicalContextStaleError(body.error.message)
    : null;
}

/**
 * A refused whole-set draft preview, read the way the governed preparation's refusals are read. A
 * preview this server cannot make is ClinicalLabPreviewUnavailableError, so the caller prepares the
 * forms instead.
 */
async function labDraftSetPreviewRefusal(response: Response): Promise<Error> {
  const stale = await contextStaleRefusal(response);
  if (stale !== null) return stale;
  const proposals = await formOrderProposalsRefusal(response);
  if (proposals !== null) return proposals;
  const declinedOnOrder = await declinedTestOnOrderRefusal(response);
  if (declinedOnOrder !== null) return declinedOnOrder;
  const body = (await response.json().catch(() => null)) as {
    error?: { code?: string; message?: string; detail?: string };
  } | null;
  const message = body?.error?.message ?? "The requisition preview could not be rendered.";
  if (
    response.status === 404 ||
    response.status === 503 ||
    (response.status === 409 && body?.error?.detail === "lab_form_selection_needs_preparation")
  )
    return new ClinicalLabPreviewUnavailableError(message);
  if (response.status === 409 && body?.error?.code === "CONFLICT")
    return new ClinicalWriteConflictError(message);
  return new Error(message);
}

/** Unsaved draft content rendered on its whole form set, with its PDF decoded. */
export type LabOrderDraftContentPreviewResult = Omit<LabOrderDraftContentPreview, "pdfBase64"> & {
  readonly bytes: Uint8Array;
};

export class PatientEducationRequestError extends Error {
  constructor(
    message: string,
    public readonly status: number,
  ) {
    super(message);
  }
}

/** A definitive HTTP refusal can be corrected; transport failures keep their frozen retry. */
export class PatientProfileWriteRequestError extends Error {
  constructor(
    message: string,
    public readonly status: number,
  ) {
    super(message);
  }
}

export class EncounterDiscussionContextChangedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "EncounterDiscussionContextChangedError";
  }
}

async function patientEducationRefusal(response: Response): Promise<Error> {
  const body = (await response.json().catch(() => null)) as {
    error?: { message?: unknown };
  } | null;
  return new PatientEducationRequestError(
    typeof body?.error?.message === "string"
      ? body.error.message
      : blockedClinicalRequest(response, "The handout request failed. Retry before closing.")
          .message,
    response.status,
  );
}

/** An ad-hoc handout route answers only with an ad-hoc handout, never the plan's (EXECDEV-251). */
function adhocPatientEducationDraft(draft: PatientEducationDraft): PatientEducationDraft {
  if ((draft.origin ?? "plan") !== "adhoc")
    throw new Error("The saved handout does not match the requested patient handout");
  return draft;
}

/**
 * A definitive HTTP refusal, carrying its status so a reader can tell "this
 * role may not" (401/403, shown as nothing) from "this could not be loaded"
 * (everything else, shown with a retry). The message is unchanged from the
 * plain Error it replaces, and so is the name.
 */
export class ClinicalRequestError extends Error {
  constructor(
    message: string,
    public readonly status: number,
  ) {
    super(message);
  }
}

/** True for a 401/403: the role may not read this, and asking again changes nothing. */
export function isAccessRefusal(error: unknown): boolean {
  return error instanceof ClinicalRequestError && (error.status === 401 || error.status === 403);
}

/**
 * The server's own words for a refusal the clinic's settings made (a feature
 * this clinic has turned off), which the generic 403 wording would hide.
 */
async function policyRefusal(response: Response): Promise<ClinicalRequestError | null> {
  if (response.status !== 403) return null;
  const body = (await response
    .clone()
    .json()
    .catch(() => null)) as { error?: { code?: unknown; message?: unknown } } | null;
  return body?.error?.code === "POLICY_BLOCKED" && typeof body.error.message === "string"
    ? new ClinicalRequestError(body.error.message, response.status)
    : null;
}

function blockedClinicalRequest(response: Response, fallback: string): ClinicalRequestError {
  if (response.status === 409) {
    return new ClinicalRequestError(
      "The authoritative workflow changed. Reload its exact state before acting.",
      response.status,
    );
  }
  if (response.status === 403) {
    return new ClinicalRequestError(
      "The active AAL2 clinician scope no longer authorizes this operation.",
      response.status,
    );
  }
  if (response.status === 400 || response.status === 422) {
    return new ClinicalRequestError(
      "The exact clinical payload failed authoritative validation.",
      response.status,
    );
  }
  return new ClinicalRequestError(fallback, response.status);
}

async function* decodedChunks(stream: ReadableStream<Uint8Array>): AsyncGenerator<string> {
  const reader = stream.getReader();
  const decoder = new TextDecoder();
  try {
    while (true) {
      const result = await reader.read();
      if (result.done) break;
      yield decoder.decode(result.value, { stream: true });
    }
    const tail = decoder.decode();
    if (tail.length > 0) yield tail;
  } finally {
    reader.releaseLock();
  }
}

export async function* parseSse(
  stream: ReadableStream<Uint8Array>,
): AsyncGenerator<AgentStreamEvent> {
  let buffer = "";
  for await (const chunk of decodedChunks(stream)) {
    buffer += chunk.replaceAll("\r\n", "\n");
    let boundary = buffer.indexOf("\n\n");
    while (boundary >= 0) {
      const frame = buffer.slice(0, boundary);
      buffer = buffer.slice(boundary + 2);
      boundary = buffer.indexOf("\n\n");
      if (frame.length === 0 || frame.startsWith(":")) continue;

      let id: number | undefined;
      let type = "message";
      const data: string[] = [];
      for (const line of frame.split("\n")) {
        const separator = line.indexOf(":");
        const field = separator < 0 ? line : line.slice(0, separator);
        const rawValue = separator < 0 ? "" : line.slice(separator + 1);
        const value = rawValue.startsWith(" ") ? rawValue.slice(1) : rawValue;
        if (field === "id") id = Number(value);
        else if (field === "event") type = value;
        else if (field === "data") data.push(value);
      }
      if (!Number.isInteger(id) || data.length === 0) continue;
      yield { id: id as number, type, data: JSON.parse(data.join("\n")) as unknown };
    }
  }
}

export function createAgentClient(options: AgentClientOptions) {
  const request = options.fetch ?? fetch;
  const authorizedHeaders = async (): Promise<Record<string, string>> => {
    const token = await options.getAccessToken();
    if (token.length === 0) throw new Error("A valid workforce session is required");
    return {
      authorization: `Bearer ${token}`,
      ...(options.siteId === undefined ? {} : { "x-site-id": options.siteId }),
    };
  };

  /** A JSON route: GET without a body, POST with one. Sub-clients read the response. */
  const jsonRoute = async (path: string, body?: unknown, signal?: AbortSignal) =>
    request(sameOriginUrl(options.baseUrl, path), {
      method: body === undefined ? "GET" : "POST",
      headers: {
        ...(await authorizedHeaders()),
        ...(body === undefined ? {} : { "content-type": "application/json" }),
      },
      ...(body === undefined ? {} : { body: JSON.stringify(body) }),
      cache: "no-store",
      credentials: "same-origin",
      ...(signal === undefined ? {} : { signal }),
    });

  /** Shared POST body/receipt handling for the three chart-history writers. */
  const recordChartHistory = async (
    collection: "problems" | "medications" | "allergies",
    siteId: string,
    patientId: string,
    input: unknown,
    signal?: AbortSignal,
  ) => {
    const response = await request(
      sameOriginUrl(options.baseUrl, `/v1/patients/${encodeURIComponent(patientId)}/${collection}`),
      {
        method: "POST",
        headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
        body: JSON.stringify({ siteId, input }),
        cache: "no-store",
        credentials: "same-origin",
        ...(signal === undefined ? {} : { signal }),
      },
    );
    if (response.status === 409) {
      throw new ClinicalWriteConflictError(
        "This chart entry was already superseded; reload the chart and try again.",
      );
    }
    if (!response.ok) {
      throw blockedClinicalRequest(response, "The chart entry could not be recorded");
    }
    return ChartRecordReceiptSchema.parse(unwrapRpcResult(await response.json()));
  };

  return {
    ...createFaxesClient(async (path, init) =>
      request(sameOriginUrl(options.baseUrl, path), {
        ...init,
        headers: { ...(await authorizedHeaders()), ...init?.headers },
        cache: "no-store",
        credentials: "same-origin",
      }),
    ),
    ...createIncomingDocumentsClient(async (path, init) =>
      request(sameOriginUrl(options.baseUrl, path), {
        ...init,
        headers: { ...(await authorizedHeaders()), ...init?.headers },
        cache: "no-store",
        credentials: "same-origin",
      }),
    ),
    ...createClinicConversationsClient(jsonRoute),
    ...createPatientDocumentsClient(jsonRoute),
    ...createPatientDocumentDeliveriesClient(jsonRoute),
    ...createPatientConsentsClient(jsonRoute),
    ...createSchedulingIntakeClient(jsonRoute),
    ...createPatientMessagingClient(jsonRoute),
    ...createPatientMessagingSettingsClient(jsonRoute),
    ...createHealthCardPhotosClient(async (path, init) =>
      request(sameOriginUrl(options.baseUrl, path), {
        ...init,
        headers: { ...(await authorizedHeaders()), ...init.headers },
        cache: "no-store",
        credentials: "same-origin",
      }),
    ),
    async searchFdbCanadaEvaluationMedications(query: string, signal?: AbortSignal) {
      const parameters = new URLSearchParams({ query, limit: "20" });
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/fdb-canada-demo/medications?${parameters.toString()}`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(
          response,
          "The FDB Canada evaluation lookup could not be loaded",
        );
      }
      return FdbCanadaEvaluationLookupResponseSchema.parse(await response.json());
    },

    async searchFdbMedications(query: string, signal?: AbortSignal) {
      const parameters = new URLSearchParams({ query, limit: "12" });
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/fdb/medications?${parameters.toString()}`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The FDB medication search could not be loaded");
      }
      return FdbMedicationSearchResponseSchema.parse(await response.json());
    },

    async searchFdbAllergens(query: string, signal?: AbortSignal) {
      const parameters = new URLSearchParams({ query, limit: "12" });
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/fdb/allergens?${parameters.toString()}`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The FDB allergen search could not be loaded");
      }
      return FdbAllergenSearchResponseSchema.parse(await response.json());
    },

    async getFdbInteractionMonograph(monographId: number, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/fdb/interaction-monographs/${encodeURIComponent(String(monographId))}`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The interaction monograph could not be loaded");
      }
      return FdbInteractionMonographSchema.parse(await response.json());
    },

    /** Screens a draft prescription against the chart; signing repeats it server-side. */
    async screenFdbPrescription(
      encounterId: string,
      input: FdbScreeningRequest,
      signal?: AbortSignal,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/prescription-screenings`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(FdbScreeningRequestSchema.parse(input)),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The prescription could not be screened");
      }
      return FdbScreeningSchema.parse(await response.json());
    },

    async createFdbCanadaDemoWorkflow(
      medication: CreateFdbCanadaDemoWorkflowRequest["medication"],
      order: FdbCanadaDemoOrder,
      idempotencyKey: string,
      signal?: AbortSignal,
    ) {
      const input = CreateFdbCanadaDemoWorkflowRequestSchema.parse({
        medication,
        order,
        idempotencyKey,
      });
      const response = await request(
        sameOriginUrl(options.baseUrl, "/v1/fdb-canada-demo/workflows"),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The non-clinical demo draft could not be created");
      }
      return FdbCanadaDemoWorkflowSchema.parse(await response.json());
    },

    async updateFdbCanadaDemoWorkflow(
      workflowId: string,
      inputValue: UpdateFdbCanadaDemoWorkflowRequest,
      signal?: AbortSignal,
    ) {
      const input = UpdateFdbCanadaDemoWorkflowRequestSchema.parse(inputValue);
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/fdb-canada-demo/workflows/${encodeURIComponent(workflowId)}/update`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The exact demo draft could not be updated");
      }
      return FdbCanadaDemoWorkflowSchema.parse(await response.json());
    },

    async transitionFdbCanadaDemoWorkflow(
      workflowId: string,
      inputValue: TransitionFdbCanadaDemoWorkflowRequest,
      signal?: AbortSignal,
    ) {
      const input = TransitionFdbCanadaDemoWorkflowRequestSchema.parse(inputValue);
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/fdb-canada-demo/workflows/${encodeURIComponent(workflowId)}/transition`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The exact mock workflow transition was blocked");
      }
      return FdbCanadaDemoWorkflowSchema.parse(await response.json());
    },

    async getLabOrderConfiguration(signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(options.baseUrl, "/v1/lab-orders/configuration"),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(
          response,
          "Laboratory ordering configuration could not be loaded",
        );
      }
      return LabOrderConfigurationSchema.parse(await response.json());
    },

    async saveLabOrderProfile(
      profileInput: SaveLabOrderProfileInput,
      idempotencyKey: string,
      signal?: AbortSignal,
    ) {
      const profile = SaveLabOrderProfileInputSchema.parse(profileInput);
      const response = await request(sameOriginUrl(options.baseUrl, "/v1/lab-order-profiles"), {
        method: "POST",
        headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
        body: JSON.stringify({ profile, idempotencyKey }),
        cache: "no-store",
        credentials: "same-origin",
        ...(signal === undefined ? {} : { signal }),
      });
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Laboratory order profile could not be saved");
      }
      return LabOrderProfileSchema.parse(await response.json());
    },

    async previewLabRequisition(actionId: string, actionVersion: number, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/lab-actions/${encodeURIComponent(actionId)}/versions/${actionVersion}/requisition-preview`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(
          response,
          "Laboratory requisition preview could not be rendered",
        );
      }
      return LabRequisitionManifestPreviewSchema.parse(await response.json());
    },

    async getLabOrder(labOrderId: string, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/lab-orders/${encodeURIComponent(labOrderId)}`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Laboratory order could not be loaded");
      }
      return PersistedLabOrderSchema.parse(await response.json());
    },

    async getImagingOrderConfiguration(signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(options.baseUrl, "/v1/imaging-orders/configuration"),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(
          response,
          "Imaging ordering configuration could not be loaded",
        );
      }
      return ImagingOrderConfigurationSchema.parse(await response.json());
    },

    /** The studies the clinic's reviewed imaging forms offer, each with the form it came from. */
    async listImagingStudyConcepts(signal?: AbortSignal) {
      const response = await request(sameOriginUrl(options.baseUrl, "/v1/imaging-orders/studies"), {
        method: "GET",
        headers: await authorizedHeaders(),
        cache: "no-store",
        credentials: "same-origin",
        ...(signal === undefined ? {} : { signal }),
      });
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The clinic's imaging studies could not be loaded");
      }
      return ClinicImagingStudyConceptListSchema.parse(await response.json());
    },

    async previewImagingRequisition(actionId: string, actionVersion: number, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/imaging-actions/${encodeURIComponent(actionId)}/versions/${actionVersion}/requisition-preview`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Imaging requisition preview could not be rendered");
      }
      return ImagingRequisitionManifestPreviewSchema.parse(await response.json());
    },

    async getImagingOrder(imagingOrderId: string, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/imaging-orders/${encodeURIComponent(imagingOrderId)}`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Imaging order could not be loaded");
      }
      return PersistedImagingOrderSchema.parse(await response.json());
    },

    async listOrderResultWorkQueue(signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(options.baseUrl, "/v1/order-results/work-queue"),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Order-result work queue could not be loaded");
      }
      return OrderResultWorkQueueSchema.parse(await response.json());
    },

    async getOrderResultWorkflow(resultId: string, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/order-results/${encodeURIComponent(resultId)}`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Order-result workflow could not be loaded");
      }
      return OrderResultWorkflowSchema.parse(await response.json());
    },

    async transitionOrderResult(
      resultId: string,
      input: OrderResultTransitionRequest,
      signal?: AbortSignal,
    ) {
      const transition = OrderResultTransitionRequestSchema.parse(input);
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/order-results/${encodeURIComponent(resultId)}/transitions`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(transition),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Order-result transition could not be recorded");
      }
      return OrderResultWorkflowSchema.parse(await response.json());
    },

    async searchReferralDirectory(specialtyCode: string, limit = 20, signal?: AbortSignal) {
      const specialty = SpecialtyCodeSchema.parse(specialtyCode);
      if (!Number.isInteger(limit) || limit < 1 || limit > 50) {
        throw new Error("Referral directory result limit must be between 1 and 50");
      }
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/referral-directory?specialtyCode=${encodeURIComponent(specialty)}&limit=${limit}`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Referral directory could not be loaded");
      }
      return ReferralDirectorySearchResultSchema.parse(await response.json());
    },

    async getClinicReferralPolicy(signal?: AbortSignal): Promise<ClinicReferralPolicy | null> {
      const response = await request(sameOriginUrl(options.baseUrl, "/v1/referral-policy"), {
        method: "GET",
        headers: await authorizedHeaders(),
        cache: "no-store",
        credentials: "same-origin",
        ...(signal === undefined ? {} : { signal }),
      });
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Referral policy could not be loaded");
      }
      return z
        .object({ policy: ClinicReferralPolicySchema.nullable() })
        .parse(await response.json()).policy;
    },

    async saveClinicReferralPolicy(
      input: SaveClinicReferralPolicyRequest,
      signal?: AbortSignal,
    ): Promise<ClinicReferralPolicy> {
      const command = SaveClinicReferralPolicyRequestSchema.parse(input);
      const response = await request(sameOriginUrl(options.baseUrl, "/v1/referral-policy"), {
        method: "POST",
        headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
        body: JSON.stringify(command),
        cache: "no-store",
        credentials: "same-origin",
        ...(signal === undefined ? {} : { signal }),
      });
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Referral policy could not be saved");
      }
      return z.object({ policy: ClinicReferralPolicySchema }).parse(await response.json()).policy;
    },

    async getEncounterContext(encounterId: string, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/encounters/${encodeURIComponent(encounterId)}/context`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) throw new Error("Encounter context could not be loaded");
      return EncounterContextSchema.parse(await response.json());
    },
    /**
     * One governed call: agent run, exact review, clinic-document selection and
     * ready-to-sign PDF draft, run server-side in order. Replaces the browser
     * driving startRun → streamRun → reviewActionBundle → select → generate.
     */
    async suggestClinicDocumentFillValues(
      input: ClinicDocumentFillSuggestionsCommand,
      signal?: AbortSignal,
    ) {
      const command = ClinicDocumentFillSuggestionsCommandSchema.parse(input);
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v2/document-selections/${encodeURIComponent(command.selectionId)}/fill-suggestions`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(command),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok)
        throw blockedClinicalRequest(response, "AI form suggestions could not be prepared");
      return ClinicDocumentFillSuggestionsResponseSchema.parse(await response.json());
    },

    async prepareLabOrder(
      encounterId: string,
      input: PrepareLabOrderRequest,
      signal?: AbortSignal,
    ): Promise<PreparedManualOrder> {
      // A "+" order (its proposal carries its marker) is answered with what preparing its forms
      // found: notices, information still missing, and whether they are the forms on screen. Its
      // refusals keep the server's plain reason and kind (ManualOrderRequestError), so its row can
      // say why nothing was ordered. A plan preparation is read exactly as before.
      const manualOrder = input.proposedLabOrder.manualOrder !== undefined;
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/lab-orders/prepare`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        if (manualOrder)
          throw await manualOrderRefusal(
            response,
            "The order could not be prepared. Nothing was ordered.",
          );
        throw (
          (await contextStaleRefusal(response)) ??
          blockedClinicalRequest(response, "The governed laboratory order could not be prepared")
        );
      }
      const body: unknown = await response.json();
      return manualOrder
        ? PreparedManualOrderSchema.parse(body)
        : PreparedLabOrderSchema.parse(body);
    },

    async previewImagingOrder(
      encounterId: string,
      input: PreviewImagingOrderRequest,
      signal?: AbortSignal,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/imaging-orders/preview`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal ? { signal } : {}),
        },
      );
      if (!response.ok)
        throw (
          (await policyBlockedRefusal(response)) ??
          blockedClinicalRequest(response, "The imaging requisition preview could not be created")
        );
      return ImagingOrderDraftPreviewSchema.parse(await response.json());
    },

    async prepareImagingOrder(
      encounterId: string,
      input: PrepareImagingOrderRequest,
      signal?: AbortSignal,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/imaging-orders/prepare`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        if (input.proposedImagingOrder.manualOrder !== undefined)
          throw await manualOrderRefusal(
            response,
            "The imaging order could not be prepared. Nothing was ordered.",
          );
        throw (
          (await contextStaleRefusal(response)) ??
          (await formOrderProposalsRefusal(response)) ??
          (await declinedTestOnOrderRefusal(response)) ??
          (await policyBlockedRefusal(response)) ??
          blockedClinicalRequest(response, "The governed imaging order could not be prepared")
        );
      }
      return PreparedImagingOrderSchema.parse(await response.json());
    },

    // ---- Draft-first laboratory ordering ----------------------------------

    async getRolloutPolicy(
      scope: RolloutScope,
      signal?: AbortSignal,
    ): Promise<RolloutPolicyReference> {
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/rollout/${encodeURIComponent(scope)}/policy`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The clinic's rollout policy could not be loaded");
      }
      return RolloutPolicyReferenceSchema.parse(await response.json());
    },

    async getPatientEducationDraft(encounterId: string, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/patient-education-drafts/current`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) throw await patientEducationRefusal(response);
      return PatientEducationDraftEnvelopeSchema.nullable().parse(await response.json());
    },
    async savePatientEducationDraft(encounterId: string, input: SavePatientEducationDraftRequest) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/patient-education-drafts`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
        },
      );
      if (!response.ok) throw await patientEducationRefusal(response);
      return PatientEducationDraftEnvelopeSchema.parse(await response.json());
    },
    async executePatientEducationDraft(
      encounterId: string,
      draftId: string,
      input: PatientEducationDraftTransition,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/patient-education-drafts/${encodeURIComponent(draftId)}/execute`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
        },
      );
      if (!response.ok) throw await patientEducationRefusal(response);
      return PatientEducationDraftEnvelopeSchema.parse(await response.json());
    },
    async discardPatientEducationDraft(
      encounterId: string,
      draftId: string,
      input: PatientEducationDraftTransition,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/patient-education-drafts/${encodeURIComponent(draftId)}/discard`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
        },
      );
      if (!response.ok) throw await patientEducationRefusal(response);
      return PatientEducationDraftSchema.parse(await response.json());
    },

    // The Plan heading's handout (EXECDEV-251): its own slot beside the plan's, on its own paths,
    // so an API without them answers 404 and never writes into the plan's handout.
    async getAdhocPatientEducationDraft(encounterId: string, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/patient-education-drafts/adhoc/current`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) throw await patientEducationRefusal(response);
      const value = PatientEducationDraftEnvelopeSchema.nullable().parse(await response.json());
      if (value !== null) adhocPatientEducationDraft(value.draft);
      return value;
    },
    async saveAdhocPatientEducationDraft(
      encounterId: string,
      input: SavePatientEducationDraftRequest,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/patient-education-drafts/adhoc`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
        },
      );
      if (!response.ok) throw await patientEducationRefusal(response);
      const value = PatientEducationDraftEnvelopeSchema.parse(await response.json());
      adhocPatientEducationDraft(value.draft);
      return value;
    },
    async executeAdhocPatientEducationDraft(
      encounterId: string,
      draftId: string,
      input: PatientEducationDraftTransition,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/patient-education-drafts/adhoc/${encodeURIComponent(draftId)}/execute`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
        },
      );
      if (!response.ok) throw await patientEducationRefusal(response);
      const value = PatientEducationDraftEnvelopeSchema.parse(await response.json());
      adhocPatientEducationDraft(value.draft);
      return value;
    },
    async discardAdhocPatientEducationDraft(
      encounterId: string,
      draftId: string,
      input: PatientEducationDraftTransition,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/patient-education-drafts/adhoc/${encodeURIComponent(draftId)}/discard`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
        },
      );
      if (!response.ok) throw await patientEducationRefusal(response);
      return adhocPatientEducationDraft(PatientEducationDraftSchema.parse(await response.json()));
    },

    async getLabOrderDraft(
      encounterId: string,
      signal?: AbortSignal,
    ): Promise<LabOrderDraftEnvelope> {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/lab-order-drafts/current`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The laboratory order draft could not be loaded");
      }
      return LabOrderDraftEnvelopeSchema.parse(await response.json());
    },

    async upsertLabOrderDraft(
      encounterId: string,
      input: UpsertLabOrderDraftRequest,
      signal?: AbortSignal,
    ): Promise<LabOrderDraft & { readonly notice?: string }> {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/lab-order-drafts`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The laboratory order draft could not be saved");
      }
      const { droppedValues, notice, ...draft } = (await response.json()) as Record<
        string,
        unknown
      >;
      const saved = LabOrderDraftSchema.parse(draft);
      z.array(PreparedFormEntrySchema).optional().parse(droppedValues);
      return typeof notice === "string" && notice.trim() ? { ...saved, notice } : saved;
    },

    async discardLabOrderDraft(
      encounterId: string,
      draftId: string,
      input: DiscardLabOrderDraftRequest,
      signal?: AbortSignal,
    ): Promise<LabOrderDraft> {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/lab-order-drafts/${encodeURIComponent(draftId)}/discard`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The laboratory order draft could not be discarded");
      }
      return LabOrderDraftSchema.parse(await response.json());
    },

    async prepareLabOrderDraft(
      encounterId: string,
      draftId: string,
      input: PrepareLabOrderDraftRequest,
      signal?: AbortSignal,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/lab-order-drafts/${encodeURIComponent(draftId)}/prepare`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        const stale = await contextStaleRefusal(response);
        if (stale !== null) throw stale;
        const proposals = await formOrderProposalsRefusal(response);
        if (proposals !== null) throw proposals;
        const declinedOnOrder = await declinedTestOnOrderRefusal(response);
        if (declinedOnOrder !== null) throw declinedOnOrder;
        const body = (await response.json().catch(() => null)) as {
          error?: { code?: string; message?: string; detail?: string };
        } | null;
        const message =
          body?.error?.message ?? "The complete requisition set could not be prepared.";
        // A version the record moved past: typed so the caller re-reads the
        // record before the next attempt instead of replaying the same pin.
        if (response.status === 409 && body?.error?.code === "CONFLICT")
          throw new ClinicalWriteConflictError(message);
        throw new Error(message);
      }
      return z
        .object({
          prepared: PreparedLabOrderSchema,
          draftVersion: z.number().int().positive(),
          document: LabOrderDraftDocumentSchema.nullable(),
          documents: z.array(LabOrderDraftDocumentSchema),
          documentNames: z.record(z.string(), z.string()).optional(),
          // Saved entries the prepared forms no longer have, by plain name.
          omittedValues: z
            .array(z.object({ formName: z.string(), fieldLabel: z.string() }))
            .optional(),
          // Non-blocking notes, such as a field left for the clinician to complete.
          notices: PreparedFormNoticesSchema.optional(),
          // Required information still missing: the forms can be completed, not signed.
          incomplete: PreparedFormsIncompleteSchema.optional(),
          // The prepared forms are exactly the previewed ones, so their field sets are not sent.
          previewMatches: z.boolean().optional(),
        })
        .refine(
          (body) =>
            body.documents.length > 0 ||
            body.previewMatches === true ||
            body.prepared.preview === null,
          { message: "Prepared forms that differ from the preview must carry their field sets" },
        )
        .parse(await response.json());
    },

    /**
     * The draft rendered on every form it needs, as one PDF, without preparing it for signing.
     * Nothing is recorded, so it is fast. Refusals read as the governed preparation's do; a
     * preview this server cannot make is ClinicalLabPreviewUnavailableError.
     */
    async previewLabOrderDraftSet(
      encounterId: string,
      draftId: string,
      input: PreviewLabOrderDraftRequest,
      signal?: AbortSignal,
    ): Promise<LabOrderDraftSetPreviewResult> {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/lab-order-drafts/${encodeURIComponent(draftId)}/preview`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) throw await labDraftSetPreviewRefusal(response);
      const { pdfBase64, ...preview } = LabOrderDraftSetPreviewSchema.parse(await response.json());
      return {
        ...preview,
        bytes: Uint8Array.from(atob(pdfBase64), (value) => value.charCodeAt(0)),
      };
    },

    /**
     * Unsaved draft content on every form it needs, rendered exactly as the saved draft's preview
     * renders the same draft, so it can run while that content is being saved. Nothing is read from
     * or written to the saved draft. Refusals read as the saved draft's preview's do; a server
     * without this preview is ClinicalLabPreviewUnavailableError.
     */
    async previewLabOrderDraftContent(
      encounterId: string,
      input: PreviewLabOrderDraftContentRequest,
      signal?: AbortSignal,
    ): Promise<LabOrderDraftContentPreviewResult> {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/lab-order-draft-previews`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) throw await labDraftSetPreviewRefusal(response);
      const { pdfBase64, ...preview } = LabOrderDraftContentPreviewSchema.parse(
        await response.json(),
      );
      return {
        ...preview,
        bytes: Uint8Array.from(atob(pdfBase64), (value) => value.charCodeAt(0)),
      };
    },

    /**
     * The draft rendered on the site's published requisition. Binary PDF with
     * the form's identity in headers; the editable bindings come from the
     * draft envelope.
     */
    async previewLabOrderDraft(
      encounterId: string,
      draftId: string,
      signal?: AbortSignal,
    ): Promise<{
      readonly bytes: Uint8Array;
      readonly draftVersion: number;
      readonly document: LabOrderDraftDocument;
    }> {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/lab-order-drafts/${encodeURIComponent(draftId)}/preview.pdf`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        const body = (await response.json().catch(() => null)) as {
          error?: { code?: unknown; message?: unknown };
        } | null;
        if (
          response.status === 409 &&
          body?.error?.code === "POLICY_BLOCKED" &&
          typeof body.error.message === "string" &&
          body.error.message.length > 0
        ) {
          throw new Error(body.error.message);
        }
        throw blockedClinicalRequest(response, "The requisition preview could not be rendered");
      }
      const contentType = response.headers.get("content-type") ?? "";
      if (!contentType.startsWith("application/pdf")) {
        throw new Error("The requisition preview did not come back as a PDF");
      }
      // Only the form's identity rides in headers; its editable bindings come
      // from the draft envelope (GET …/lab-order-drafts/current), a JSON body
      // with no header-size ceiling.
      const document = LabOrderDraftDocumentSchema.parse({
        documentId: response.headers.get("x-clinic-document-id"),
        documentVersion: Number(response.headers.get("x-clinic-document-version")),
        documentVersionHash: response.headers.get("x-clinic-document-version-hash"),
        fields: [],
      });
      return {
        bytes: new Uint8Array(await response.arrayBuffer()),
        draftVersion: Number(response.headers.get("x-lab-order-draft-version")),
        document,
      };
    },

    async signLabOrderDraft(
      encounterId: string,
      draftId: string,
      input: SignLabOrderDraftRequest,
      signal?: AbortSignal,
    ): Promise<LabOrderSignReceipt> {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/lab-order-drafts/${encodeURIComponent(draftId)}/sign`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        const stale = await contextStaleRefusal(response);
        if (stale !== null) throw stale;
        // A changed form must reopen preparation, not retry the cached PDF.
        if (response.status === 409) {
          const body = await response
            .clone()
            .json()
            .catch(() => null);
          // Missing signing prerequisites need their actionable policy
          // explanation; they do not invalidate the reviewed version pin.
          if (body?.error?.code === "POLICY_BLOCKED") {
            throw new Error(
              typeof body.error.message === "string" && body.error.message.trim().length > 0
                ? body.error.message
                : "The laboratory order is blocked by clinic policy.",
            );
          }
          if (
            body?.error?.code === "CONFLICT" &&
            body.error.detail === "lab_preview_form_changed"
          ) {
            // The server names what moved (the note, the draft, the forms or
            // their instructions); every case is resolved by Prepare again.
            throw new ClinicalLabFormChangedError(
              typeof body.error.message === "string" && body.error.message.trim().length > 0
                ? body.error.message
                : "The clinic's requisition form changed. Prepare again and review the updated preview before signing.",
            );
          }
          // The order is already on the chart: never Prepare again, which
          // would order it twice. The server's words say what to do instead.
          if (
            body?.error?.code === "CONFLICT" &&
            body.error.detail === "lab_order_already_placed" &&
            typeof body.error.message === "string" &&
            body.error.message.trim().length > 0
          ) {
            throw new ClinicalWriteConflictError(body.error.message);
          }
        }
        // Any other 409 is a version pin the record moved past (encounter or
        // draft); typed so the bridge can drop its cached pin and re-read.
        if (response.status === 409) {
          throw new ClinicalWriteConflictError(
            "The authoritative workflow changed. Reload its exact state before acting.",
          );
        }
        throw blockedClinicalRequest(response, "The laboratory order could not be signed");
      }
      return LabOrderSignReceiptSchema.parse(await response.json());
    },

    async cancelLabOrder(
      actionId: string,
      actionVersion: number,
      input: CancelLabOrderRequest,
      signal?: AbortSignal,
    ): Promise<LabOrderCancellationReceipt> {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/lab-orders/${encodeURIComponent(actionId)}/versions/${actionVersion}/cancellation`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The laboratory order could not be cancelled");
      }
      return LabOrderCancellationReceiptSchema.parse(await response.json());
    },

    async startRun(input: AgentRunRequestDto, signal?: AbortSignal): Promise<AgentRunAcceptedDto> {
      const response = await request(sameOriginUrl(options.baseUrl, "/v1/agent/runs"), {
        method: "POST",
        headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
        body: JSON.stringify(input),
        cache: "no-store",
        credentials: "same-origin",
        ...(signal === undefined ? {} : { signal }),
      });
      if (!response.ok) throw new Error("Agent run could not be started");
      return parseAccepted(await response.json());
    },

    async *streamRun(
      accepted: AgentRunAcceptedDto,
      optionsForStream: { readonly afterEventId?: number; readonly signal?: AbortSignal } = {},
    ): AsyncGenerator<AgentStreamEvent> {
      const headers = await authorizedHeaders();
      if (optionsForStream.afterEventId !== undefined) {
        headers["last-event-id"] = String(optionsForStream.afterEventId);
      }
      const response = await request(sameOriginUrl(options.baseUrl, accepted.eventsUrl), {
        method: "GET",
        headers,
        cache: "no-store",
        credentials: "same-origin",
        ...(optionsForStream.signal === undefined ? {} : { signal: optionsForStream.signal }),
      });
      if (!response.ok || response.body === null) {
        throw new Error("Agent event stream could not be opened");
      }
      for await (const event of parseSse(response.body)) yield event;
    },

    async reviewActionBundle(bundleId: string, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/action-bundles/${encodeURIComponent(bundleId)}/review`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Care Bundle review could not be loaded");
      }
      return ActionBundleReviewSchema.parse(await response.json());
    },

    async acceptActionBundle(
      bundleId: string,
      acceptance: AtomicAcceptanceRequest,
      signal?: AbortSignal,
    ) {
      if (acceptance.bundleId !== bundleId) {
        throw new Error("Care Bundle acceptance must target the reviewed bundle");
      }
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/action-bundles/${encodeURIComponent(bundleId)}/acceptance`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(acceptance),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw (
          (await contextStaleRefusal(response)) ??
          blockedClinicalRequest(response, "Care Bundle acceptance could not be recorded")
        );
      }
      return LocalAcceptanceReceiptSchema.parse(await response.json());
    },

    async submitDraftReviewFeedback(
      bundleId: string,
      feedback: DraftReviewFeedback,
      signal?: AbortSignal,
    ) {
      if (feedback.bundleId !== bundleId) {
        throw new Error("Draft feedback must target the reviewed Care Bundle");
      }
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/action-bundles/${encodeURIComponent(bundleId)}/draft-feedback`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(feedback),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Draft review feedback could not be recorded");
      }
      return DraftReviewFeedbackReceiptSchema.parse(await response.json());
    },

    /** Who a sealed print-and-send package lands with by default (REF-10). */
    async getReferralHandoffDefault(signal?: AbortSignal) {
      const siteId = options.siteId;
      if (siteId === undefined) {
        throw new Error("A clinic site is required for the referral hand-off setting");
      }
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/referral-handoff-default?siteId=${encodeURIComponent(siteId)}`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The referral hand-off setting could not be loaded");
      }
      return ReferralHandoffDefaultSchema.parse(await response.json());
    },

    async saveReferralHandoffDefault(
      input: Omit<SaveReferralHandoffDefaultRequest, "siteId">,
      signal?: AbortSignal,
    ) {
      const body = SaveReferralHandoffDefaultRequestSchema.parse({
        ...input,
        siteId: options.siteId,
      });
      const response = await request(
        sameOriginUrl(options.baseUrl, "/v1/referral-handoff-default"),
        {
          method: "PUT",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (response.status === 409)
        throw new ClinicalWriteConflictError(
          "The hand-off setting changed. Reload to see the current choice.",
        );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The referral hand-off setting could not be saved");
      }
      return ReferralHandoffDefaultSchema.parse(await response.json());
    },

    /** The clinic's referral directory (REF-7). */
    async listReferralDirectory(specialty?: string, signal?: AbortSignal) {
      const siteId = options.siteId;
      if (siteId === undefined) {
        throw new Error("A clinic site is required for the referral directory");
      }
      const query = new URLSearchParams({ siteId });
      if (specialty !== undefined) query.set("specialty", specialty);
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/referral-directory/entries?${query.toString()}`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The referral directory could not be loaded");
      }
      return ReferralDirectoryEntrySchema.array().parse(await response.json());
    },

    async saveReferralDirectoryEntry(
      input: { readonly entry: ReferralDirectoryEntryInput; readonly supersedesId?: string },
      signal?: AbortSignal,
    ) {
      const siteId = options.siteId;
      if (siteId === undefined) {
        throw new Error("A clinic site is required for the referral directory");
      }
      const body = SaveReferralDirectoryEntryRequestSchema.parse({
        siteId,
        entry: input.entry,
        ...(input.supersedesId === undefined ? {} : { supersedesId: input.supersedesId }),
      });
      const response = await request(
        sameOriginUrl(options.baseUrl, "/v1/referral-directory/entries"),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (response.status === 409)
        throw new ClinicalWriteConflictError(
          "This directory entry changed. Reload the directory and try again.",
        );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The directory entry could not be saved");
      }
      return ReferralDirectoryEntrySchema.parse(await response.json());
    },

    async listReferralWorkQueue(signal?: AbortSignal) {
      const response = await request(sameOriginUrl(options.baseUrl, "/v1/referrals/work-queue"), {
        method: "GET",
        headers: await authorizedHeaders(),
        cache: "no-store",
        credentials: "same-origin",
        ...(signal === undefined ? {} : { signal }),
      });
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Referral work queue could not be loaded");
      }
      return ReferralWorkQueueSchema.parse(await response.json());
    },

    async getReferralWorkflow(referralId: string, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/referrals/${encodeURIComponent(referralId)}`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Referral tracking could not be loaded");
      }
      return ReferralWorkflowSchema.parse(await response.json());
    },

    async transitionReferralWorkflow(
      referralId: string,
      input: ReferralTransitionRequest,
      signal?: AbortSignal,
    ) {
      const transition = ReferralTransitionRequestSchema.parse(input);
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/referrals/${encodeURIComponent(referralId)}/transitions`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(transition),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Referral transition could not be recorded");
      }
      return ReferralWorkflowSchema.parse(await response.json());
    },

    async getTodayBoard(siteId: string, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/board?siteId=${encodeURIComponent(siteId)}`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The persisted Today board could not be loaded");
      }
      return TodayBoardSchema.parse(unwrapRpcResult(await response.json(), "patients"));
    },

    async searchWalkInPatients(siteId: string, query: string, signal?: AbortSignal) {
      const body = WalkInPatientSearchQuerySchema.parse({ siteId, query, limit: 10 });
      const response = await request(
        sameOriginUrl(options.baseUrl, "/v1/patients/walk-in-search"),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok)
        throw blockedClinicalRequest(response, "Patient search could not be loaded");
      return WalkInPatientMatchesSchema.parse(unwrapRpcResult(await response.json()));
    },

    async listPatientDirectory(siteId: string, query?: string, limit = 50, signal?: AbortSignal) {
      if (!Number.isInteger(limit) || limit < 1 || limit > 100) {
        throw new Error("Patient directory result limit must be between 1 and 100");
      }
      const parameters = new URLSearchParams({ siteId, limit: String(limit) });
      const trimmedQuery = query?.trim() ?? "";
      if (trimmedQuery.length > 0) parameters.set("query", trimmedQuery);
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/patients/directory?${parameters.toString()}`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The patient directory could not be loaded");
      }
      return PatientDirectorySchema.parse(unwrapRpcResult(await response.json()));
    },

    async listPatientEncounters(
      siteId: string,
      patientId: string,
      limit = 20,
      signal?: AbortSignal,
    ) {
      if (!Number.isInteger(limit) || limit < 1 || limit > 50) {
        throw new Error("Patient encounter history limit must be between 1 and 50");
      }
      const parameters = new URLSearchParams({ siteId, limit: String(limit) });
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(patientId)}/encounters?${parameters.toString()}`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The patient visit history could not be loaded");
      }
      return PatientEncounterHistorySchema.parse(unwrapRpcResult(await response.json()));
    },

    async listPatientLabResults(
      siteId: string,
      patientId: string,
      limit = 200,
      signal?: AbortSignal,
    ) {
      if (!Number.isInteger(limit) || limit < 1 || limit > 500) {
        throw new Error("Patient laboratory result limit must be between 1 and 500");
      }
      const parameters = new URLSearchParams({ siteId, limit: String(limit), mode: "list" });
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(patientId)}/lab-results?${parameters.toString()}`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(
          response,
          "The patient's laboratory values could not be loaded",
        );
      }
      const result = PatientLabResultsSchema.parse(unwrapRpcResult(await response.json()));
      if (result.patientId !== patientId || result.siteId !== siteId) {
        throw new Error("Laboratory values did not match the requested patient and clinic");
      }
      return result;
    },

    async listPatientLabTrends(siteId: string, patientId: string, signal?: AbortSignal) {
      const parameters = new URLSearchParams({ siteId, mode: "trend" });
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(patientId)}/lab-results?${parameters.toString()}`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The laboratory value trends could not be loaded");
      }
      const result = PatientLabTrendsSchema.parse(unwrapRpcResult(await response.json()));
      if (result.patientId !== patientId || result.siteId !== siteId) {
        throw new Error("Laboratory value trends did not match the requested patient and clinic");
      }
      return result;
    },

    async listPatientLegacyVisits(
      siteId: string,
      patientId: string,
      limit = 50,
      signal?: AbortSignal,
    ) {
      if (!Number.isInteger(limit) || limit < 1 || limit > 200) {
        throw new Error("Imported visit limit must be between 1 and 200");
      }
      const parameters = new URLSearchParams({ siteId, limit: String(limit) });
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(patientId)}/legacy-visits?${parameters.toString()}`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The imported visit history could not be loaded");
      }
      const result = PatientLegacyVisitsSchema.parse(unwrapRpcResult(await response.json()));
      if (result.patientId !== patientId || result.siteId !== siteId) {
        throw new Error("Imported visits did not match the requested patient and clinic");
      }
      return result;
    },

    async listPatientSignedNotes(
      siteId: string,
      patientId: string,
      limit = 10,
      signal?: AbortSignal,
    ) {
      if (!Number.isInteger(limit) || limit < 1 || limit > 20) {
        throw new Error("Signed note history limit must be between 1 and 20");
      }
      const parameters = new URLSearchParams({ siteId, limit: String(limit) });
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(patientId)}/signed-notes?${parameters.toString()}`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Prior signed notes could not be loaded");
      }
      return PatientSignedNotesSchema.parse(unwrapRpcResult(await response.json()));
    },

    /**
     * Role-projected patient profile (`GET /v1/patients/:id/profile`). Front
     * desk and clinic admin receive demographics only; the clinical sections
     * are absent rather than empty.
     */
    async getPatientProfile(siteId: string, patientId: string, signal?: AbortSignal) {
      const parameters = new URLSearchParams({ siteId });
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(patientId)}/profile?${parameters.toString()}`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The patient profile could not be loaded");
      }
      return PatientProfileSchema.parse(unwrapRpcResult(await response.json(), "profile"));
    },

    async listClinicPhysicians(siteId: string, signal?: AbortSignal) {
      z.string().uuid().parse(siteId);
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/clinic/physicians?${new URLSearchParams({ siteId })}`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal ? { signal } : {}),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The clinic physicians could not be loaded");
      }
      const result = ClinicPhysiciansResponseSchema.parse(unwrapRpcResult(await response.json()));
      if (result.siteId !== siteId)
        throw new Error("Physicians did not match the requested clinic");
      return result;
    },

    async updatePatientPhysician(
      patientId: string,
      input: UpdatePatientPhysicianRequest,
      signal?: AbortSignal,
    ) {
      z.string().uuid().parse(patientId);
      const body = UpdatePatientPhysicianRequestSchema.parse(input);
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/patients/${encodeURIComponent(patientId)}/physician`),
        {
          method: "PUT",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal ? { signal } : {}),
        },
      );
      if (response.status === 409) {
        throw new ClinicalWriteConflictError(
          "This physician assignment changed elsewhere. Reload and review your choice.",
        );
      }
      if (!response.ok) {
        throw new PatientProfileWriteRequestError(
          "The physician assignment could not be saved. Your choice has been kept.",
          response.status,
        );
      }
      const receipt = PatientPhysicianUpdateReceiptSchema.parse(
        unwrapRpcResult(await response.json()),
      );
      if (
        receipt.patientId !== patientId ||
        receipt.siteId !== body.siteId ||
        (receipt.roster.physician?.userId ?? null) !== body.physicianUserId ||
        receipt.roster.version !== body.expectedVersion + 1
      ) {
        throw new Error(
          "The physician assignment receipt did not match the requested patient, clinic, physician or version",
        );
      }
      return receipt;
    },

    /** CD-3 render boundary; the caller keeps edited wording until generation succeeds. */
    async renderEncounterLetter(
      encounterId: string,
      input: LetterRenderRequest,
      signal?: AbortSignal,
    ) {
      const body = LetterRenderRequestSchema.parse(input);
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/letters/render`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal ? { signal } : {}),
        },
      );
      if (!response.ok) {
        const detail = (await response.json().catch(() => null)) as {
          error?: { message?: unknown };
        } | null;
        throw new PatientProfileWriteRequestError(
          typeof detail?.error?.message === "string"
            ? detail.error.message
            : "The letter could not be generated.",
          response.status,
        );
      }
      return LetterRenderResponseSchema.parse(await response.json());
    },

    async createEncounterFollowUpTask(
      encounterId: string,
      input: CreateEncounterFollowUpTaskRequest,
      signal?: AbortSignal,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/follow-up-tasks`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(CreateEncounterFollowUpTaskRequestSchema.parse(input)),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal ? { signal } : {}),
        },
      );
      if (!response.ok) {
        const detail = (await response.json().catch(() => null)) as {
          error?: { message?: unknown };
        } | null;
        throw new PatientProfileWriteRequestError(
          typeof detail?.error?.message === "string"
            ? detail.error.message
            : "The follow-up task could not be saved.",
          response.status,
        );
      }
      return EncounterFollowUpTaskSchema.parse(((await response.json()) as { task: unknown }).task);
    },
    async listEncounterFollowUpTasks(
      encounterId: string,
      siteId: string,
      patientId: string,
      signal?: AbortSignal,
    ) {
      const query = new URLSearchParams({ siteId, patientId });
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/follow-up-tasks?${query}`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal ? { signal } : {}),
        },
      );
      if (!response.ok)
        throw blockedClinicalRequest(response, "Follow-up tasks could not be loaded");
      return EncounterFollowUpTasksSchema.parse(
        ((await response.json()) as { tasks: unknown }).tasks,
      );
    },

    async draftEncounterReferral(
      encounterId: string,
      body: EncounterReferralDraftRequest,
      signal?: AbortSignal,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/referral-draft`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(EncounterReferralDraftRequestSchema.parse(body)),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        const detail = (await response.json().catch(() => null)) as {
          error?: { message?: unknown };
        } | null;
        // The status travels with the refusal: a 409 means another save moved the
        // encounter on first, and a background draft simply tries again.
        throw new ClinicalRequestError(
          typeof detail?.error?.message === "string"
            ? detail.error.message
            : "The referral draft is unavailable. Try again or enter the referral details.",
          response.status,
        );
      }
      return EncounterReferralDraftResponseSchema.parse(await response.json());
    },

    async interpretEncounterRequest(
      encounterId: string,
      body: EncounterAssistantInterpretRequest,
      signal?: AbortSignal,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/assistant/interpret`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(EncounterAssistantInterpretRequestSchema.parse(body)),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        const detail = (await response.json().catch(() => null)) as {
          error?: { message?: unknown };
        } | null;
        throw new Error(
          typeof detail?.error?.message === "string"
            ? detail.error.message
            : "The encounter assistant is unavailable. Your text has been kept.",
        );
      }
      return EncounterAssistantInterpretResponseSchema.parse(await response.json());
    },

    async discussEncounter(
      encounterId: string,
      body: EncounterDiscussionRequest,
      signal?: AbortSignal,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/assistant/discuss`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(EncounterDiscussionRequestSchema.parse(body)),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        const detail = (await response.json().catch(() => null)) as {
          error?: { message?: unknown };
        } | null;
        throw new Error(
          typeof detail?.error?.message === "string"
            ? detail.error.message
            : "The clinical discussion is unavailable. Your question has been kept.",
        );
      }
      return EncounterDiscussionResponseSchema.parse(await response.json());
    },

    async validateEncounterDiscussionContext(
      encounterId: string,
      body: EncounterDiscussionContextCheckRequest,
      signal?: AbortSignal,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/assistant/context-check`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(EncounterDiscussionContextCheckRequestSchema.parse(body)),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        const detail = (await response.json().catch(() => null)) as {
          error?: { message?: unknown; code?: unknown };
        } | null;
        const message =
          typeof detail?.error?.message === "string"
            ? detail.error.message
            : "The patient context could not be checked. Ask again before adding this draft.";
        throw detail?.error?.code === "CONTEXT_STALE"
          ? new EncounterDiscussionContextChangedError(message)
          : new Error(message);
      }
      return EncounterDiscussionContextCheckResponseSchema.parse(await response.json());
    },

    async transcribeEncounterAudio(
      encounterId: string,
      body: EncounterAssistantTranscribeRequest,
      signal?: AbortSignal,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/assistant/transcribe`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(EncounterAssistantTranscribeRequestSchema.parse(body)),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        const detail = (await response.json().catch(() => null)) as {
          error?: { message?: unknown };
        } | null;
        throw new Error(
          typeof detail?.error?.message === "string"
            ? detail.error.message
            : "The encounter assistant is unavailable. Your text has been kept.",
        );
      }
      return PatientProfileAssistantTranscribeResponseSchema.parse(await response.json());
    },

    /** Whether this deployment answers chart questions; the composer offers them only then. */
    async getChartAssistantCapabilities(siteId: string, signal?: AbortSignal) {
      const parameters = new URLSearchParams({ siteId });
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/chart-assistant/capabilities?${parameters.toString()}`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The chart assistant's settings could not be read");
      }
      return ChartAssistantCapabilitiesSchema.parse(await response.json());
    },

    /** Answer a question about the chart outside a visit; never writes and never drafts. */
    async askPatientChart(
      patientId: string,
      body: PatientChartQuestionRequest,
      signal?: AbortSignal,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(patientId)}/assistant/ask`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(PatientChartQuestionRequestSchema.parse(body)),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        const detail = (await response.json().catch(() => null)) as {
          error?: { message?: unknown };
        } | null;
        throw new Error(
          typeof detail?.error?.message === "string"
            ? detail.error.message
            : "The chart assistant could not answer. Your question has been kept; try again.",
        );
      }
      return PatientChartQuestionResponseSchema.parse(await response.json());
    },

    /** Interpret chart additions; this endpoint never writes to the patient record. */
    async interpretPatientProfileUpdate(
      patientId: string,
      body: PatientProfileAssistantInterpretRequest,
      signal?: AbortSignal,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(patientId)}/assistant/interpret`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(PatientProfileAssistantInterpretRequestSchema.parse(body)),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        const error = (await response.json().catch(() => null)) as {
          error?: { message?: unknown };
        } | null;
        throw new Error(
          typeof error?.error?.message === "string"
            ? error.error.message
            : "The chart assistant is unavailable. Your text has been kept; try again.",
        );
      }
      return PatientProfileAssistantInterpretResponseSchema.parse(await response.json());
    },

    /** Transcription only: the returned text is reviewed in the composer before Send. */
    async transcribePatientProfileAudio(
      patientId: string,
      body: PatientProfileAssistantTranscribeRequest,
      signal?: AbortSignal,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(patientId)}/assistant/transcribe`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(PatientProfileAssistantTranscribeRequestSchema.parse(body)),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        const error = (await response.json().catch(() => null)) as {
          error?: { message?: unknown };
        } | null;
        throw new Error(
          typeof error?.error?.message === "string"
            ? error.error.message
            : "The recording could not be transcribed. Your typed text has been kept.",
        );
      }
      return PatientProfileAssistantTranscribeResponseSchema.parse(await response.json());
    },

    /**
     * The chart at a glance for the profile hero (GET /v1/patients/:id/summary):
     * generated from the current visit-context version and cached per version.
     * `refresh` re-reads the chart and regenerates when it moved. A 403 means
     * the role is identity-only; the card then keeps its client-built facts.
     */
    async getPatientProfileSummary(
      siteId: string,
      patientId: string,
      query: { readonly refresh?: boolean } = {},
      signal?: AbortSignal,
    ) {
      const parameters = new URLSearchParams({ siteId });
      if (query.refresh === true) parameters.set("refresh", "1");
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(patientId)}/summary?${parameters.toString()}`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The patient summary could not be loaded");
      }
      return PatientProfileSummarySchema.parse(unwrapRpcResult(await response.json(), "summary"));
    },

    /**
     * Replace-set write for any subset of profile sections. `expectedUpdatedAt`
     * must echo the profile's `updatedAt` token verbatim; a 409 means the chart
     * moved (stale token, superseded item, or a reused idempotency key).
     */
    async updatePatientProfile(
      patientId: string,
      body: {
        readonly siteId: string;
        readonly idempotencyKey: string;
        readonly expectedUpdatedAt: string;
        readonly profile: PatientProfileUpdateInput;
      },
      signal?: AbortSignal,
    ) {
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/patients/${encodeURIComponent(patientId)}/profile`),
        {
          method: "PUT",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (response.status === 409) {
        throw new ClinicalWriteConflictError(
          "This chart changed elsewhere; reload the profile and review your edits again.",
        );
      }
      if (!response.ok) {
        throw new PatientProfileWriteRequestError(
          blockedClinicalRequest(response, "The patient profile could not be saved").message,
          response.status,
        );
      }
      return PatientProfileUpdateReceiptSchema.parse(unwrapRpcResult(await response.json()));
    },

    /** Identity, contact and coverage write keyed by `demographics.expectedVersion`. */
    async updatePatientDemographics(
      patientId: string,
      body: {
        readonly siteId: string;
        readonly idempotencyKey: string;
        readonly demographics: PatientDemographicsUpdateInput;
      },
      signal?: AbortSignal,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(patientId)}/demographics`,
        ),
        {
          method: "PUT",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (response.status === 409) {
        throw new ClinicalWriteConflictError(
          "This patient record changed elsewhere; reload it and try again.",
        );
      }
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The patient demographics could not be saved");
      }
      return PatientDemographicsUpdateReceiptSchema.parse(unwrapRpcResult(await response.json()));
    },

    async getTodayBoardMetrics(siteId: string, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/today/metrics?siteId=${encodeURIComponent(siteId)}`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok)
        throw blockedClinicalRequest(response, "Clinic metrics could not be loaded");
      return TodayBoardMetricsSchema.parse(unwrapRpcResult(await response.json(), "metrics"));
    },

    async getTodayRooms(siteId: string, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/rooms?siteId=${encodeURIComponent(siteId)}`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok)
        throw blockedClinicalRequest(response, "The clinic rooms could not be loaded");
      const rooms = ClinicRoomsSchema.parse(unwrapRpcResult(await response.json(), "rooms"));
      if (rooms.some((room) => room.siteId !== siteId))
        throw new Error("The rooms do not match the requested clinic");
      return rooms;
    },

    async createClinicRoom(input: CreateClinicRoomRequest, signal?: AbortSignal) {
      const body = CreateClinicRoomRequestSchema.parse(input);
      const response = await request(sameOriginUrl(options.baseUrl, "/v1/rooms"), {
        method: "POST",
        headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
        body: JSON.stringify(body),
        cache: "no-store",
        credentials: "same-origin",
        ...(signal === undefined ? {} : { signal }),
      });
      if (response.status === 409)
        throw new ClinicalWriteConflictError(
          "The room list changed. Refresh rooms and review the room name before trying again.",
        );
      if (!response.ok)
        throw blockedClinicalRequest(response, "The clinic room could not be created");
      const room = ClinicRoomSchema.parse(unwrapRpcResult(await response.json(), "room"));
      if (room.siteId !== body.siteId)
        throw new Error("The room does not match the requested clinic");
      return room;
    },

    async updateClinicRoom(roomId: string, input: UpdateClinicRoomRequest, signal?: AbortSignal) {
      const body = UpdateClinicRoomRequestSchema.parse(input);
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/rooms/${encodeURIComponent(roomId)}/update`),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (response.status === 409)
        throw new ClinicalWriteConflictError(
          body.name === undefined
            ? "The room changed since the board loaded. Refresh rooms and try again."
            : "The room changed since the board loaded, or another room already has that name. Refresh rooms and try again.",
        );
      if (!response.ok)
        throw blockedClinicalRequest(response, "The clinic room could not be updated");
      const room = ClinicRoomSchema.parse(unwrapRpcResult(await response.json(), "room"));
      if (room.id !== roomId || room.siteId !== body.siteId)
        throw new Error("The room does not match the requested clinic room");
      return room;
    },

    async deleteClinicRoom(roomId: string, input: DeleteClinicRoomRequest, signal?: AbortSignal) {
      const body = DeleteClinicRoomRequestSchema.parse(input);
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/rooms/${encodeURIComponent(roomId)}/delete`),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (response.status === 409)
        throw new ClinicalWriteConflictError(
          "The room changed or now has a patient in it. Refresh rooms and try again.",
        );
      if (response.status === 404)
        throw new ClinicalWriteConflictError("This room was already deleted. Refresh rooms.");
      if (!response.ok)
        throw blockedClinicalRequest(response, "The clinic room could not be deleted");
      const receipt = DeletedClinicRoomSchema.parse(unwrapRpcResult(await response.json(), "room"));
      if (receipt.id !== roomId || receipt.siteId !== body.siteId)
        throw new Error("The deleted room does not match the requested clinic room");
      return receipt;
    },

    async assignAppointmentRoom(
      appointmentId: string,
      input: AssignAppointmentRoomRequest,
      signal?: AbortSignal,
    ) {
      const body = AssignAppointmentRoomRequestSchema.parse(input);
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/appointments/${encodeURIComponent(appointmentId)}/room`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (response.status === 409)
        throw new ClinicalWriteConflictError(
          "The appointment or room changed since the board loaded. Refresh and choose a room again.",
        );
      if (!response.ok) throw blockedClinicalRequest(response, "The room could not be assigned");
      const row = BoardQueueRowSchema.parse(unwrapRpcResult(await response.json()));
      if (row.appointmentId !== appointmentId)
        throw new Error("The room assignment does not match the requested appointment");
      return row;
    },

    async releaseAppointmentRoom(
      appointmentId: string,
      input: ReleaseAppointmentRoomRequest,
      signal?: AbortSignal,
    ) {
      const body = ReleaseAppointmentRoomRequestSchema.parse(input);
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/appointments/${encodeURIComponent(appointmentId)}/room/release`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (response.status === 409)
        throw new ClinicalWriteConflictError(
          "The appointment or room changed since the board loaded. Refresh and review the current room before trying again.",
        );
      if (!response.ok)
        throw blockedClinicalRequest(response, "The patient could not be returned to the lobby");
      const row = BoardQueueRowSchema.parse(unwrapRpcResult(await response.json()));
      if (row.appointmentId !== appointmentId)
        throw new Error("The room release does not match the requested appointment");
      return row;
    },

    async getStaffRequests(siteId = options.siteId, signal?: AbortSignal) {
      const scope = z.string().uuid().parse(siteId);
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/staff-requests?siteId=${encodeURIComponent(scope)}`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok)
        throw blockedClinicalRequest(response, "Staff requests could not be loaded");
      const rows = StaffRequestsSchema.parse(unwrapRpcResult(await response.json(), "requests"));
      if (rows.some((row) => row.siteId !== scope))
        throw new Error("Staff requests do not match the requested clinic");
      return rows;
    },

    async createStaffRequest(
      encounterId: string,
      input: CreateStaffRequestRequest,
      signal?: AbortSignal,
    ) {
      const body = CreateStaffRequestRequestSchema.parse(input);
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/staff-requests`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (response.status === 409)
        throw new ClinicalWriteConflictError(
          "The visit or request changed. Refresh before sending this staff request again.",
        );
      if (!response.ok)
        throw blockedClinicalRequest(response, "The staff request could not be sent");
      const result = StaffRequestSchema.parse(unwrapRpcResult(await response.json(), "request"));
      if (
        result.siteId !== body.siteId ||
        result.patientId !== body.patientId ||
        result.encounterId !== encounterId ||
        result.requestText !== body.requestText
      )
        throw new Error(
          "The staff request does not match this patient, encounter, and requested text",
        );
      return result;
    },

    /** A request for a patient, filed under a visit only when the item has one. */
    async createPatientStaffRequest(input: CreatePatientStaffRequestRequest, signal?: AbortSignal) {
      const body = CreatePatientStaffRequestRequestSchema.parse(input);
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(body.patientId)}/staff-requests`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (response.status === 409)
        throw new ClinicalWriteConflictError(
          "The patient or request changed. Refresh before sending this staff request again.",
        );
      if (!response.ok)
        throw blockedClinicalRequest(response, "The staff request could not be sent");
      const result = StaffRequestSchema.parse(unwrapRpcResult(await response.json(), "request"));
      if (
        result.siteId !== body.siteId ||
        result.patientId !== body.patientId ||
        (result.encounterId ?? null) !== (body.encounterId ?? null) ||
        result.requestText !== body.requestText
      )
        throw new Error("The staff request does not match this patient, visit, and requested text");
      return result;
    },

    async transitionStaffRequest(
      requestId: string,
      input: TransitionStaffRequestRequest,
      signal?: AbortSignal,
    ) {
      const body = TransitionStaffRequestRequestSchema.parse(input);
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/staff-requests/${encodeURIComponent(requestId)}/transition`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (response.status === 409)
        throw new ClinicalWriteConflictError(
          "This staff request changed. Refresh to see who has picked it up or completed it.",
        );
      if (!response.ok)
        throw blockedClinicalRequest(response, "The staff request could not be updated");
      const result = StaffRequestSchema.parse(unwrapRpcResult(await response.json(), "request"));
      if (result.id !== requestId || result.siteId !== body.siteId)
        throw new Error("The staff request does not match the requested clinic request");
      return result;
    },

    async assignStaffRequest(
      requestId: string,
      input: AssignStaffRequestRequest,
      signal?: AbortSignal,
    ) {
      const body = AssignStaffRequestRequestSchema.parse(input);
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/staff-requests/${encodeURIComponent(requestId)}/assignment`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (response.status === 409)
        throw new ClinicalWriteConflictError(
          "This staff request changed. Refresh to see who has it now.",
        );
      if (!response.ok)
        throw blockedClinicalRequest(response, "The staff request could not be handed off");
      const result = StaffRequestSchema.parse(unwrapRpcResult(await response.json(), "request"));
      if (result.id !== requestId || result.siteId !== body.siteId)
        throw new Error("The staff request does not match the requested clinic request");
      return result;
    },

    async listSiteStaff(siteId = options.siteId, signal?: AbortSignal) {
      const scope = z.string().uuid().parse(siteId);
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/site-staff?siteId=${encodeURIComponent(scope)}`),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) throw blockedClinicalRequest(response, "Clinic staff could not be listed");
      const result = SiteStaffListSchema.parse(await response.json());
      if (result.siteId !== scope)
        throw new Error("Clinic staff do not match the requested clinic");
      return result;
    },

    async transitionAppointment(
      appointmentId: string,
      input: {
        siteId: string;
        expectedVersion: number;
        targetStatus:
          | "waiting"
          | "roomed"
          | "in_progress"
          | "ready_for_discharge"
          | "completed"
          | "cancelled"
          | "left";
        room?: string;
      },
      signal?: AbortSignal,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/appointments/${encodeURIComponent(appointmentId)}/transition`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (response.status === 409) {
        if (input.targetStatus === "completed") {
          const body = (await response.json().catch(() => null)) as {
            error?: { code?: unknown };
          } | null;
          if (body?.error?.code === "POLICY_BLOCKED") {
            throw new Error(
              "This visit cannot be completed yet. Open the encounter, sign the note, then refresh Today. Signing automatically marks the visit done.",
            );
          }
        }
        throw new ClinicalWriteConflictError(
          "The appointment changed since the board loaded; refresh and try again.",
        );
      }
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The appointment could not be moved");
      }
      return BoardQueueRowSchema.parse(unwrapRpcResult(await response.json()));
    },

    async getPatientCareWork(siteId: string, patientId: string, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(patientId)}/care-work?${new URLSearchParams({ siteId })}`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Patient follow-up could not be loaded");
      }
      const result = PatientCareWorkSchema.parse(unwrapRpcResult(await response.json()));
      if (result.patientId !== patientId || result.siteId !== siteId) {
        throw new Error("Follow-up did not match the requested patient and clinic");
      }
      return result;
    },

    async getVisitContext(
      siteId: string,
      patientId: string,
      contextOptions: VisitContextRequestOptions = {},
      signal?: AbortSignal,
    ) {
      const parsed = VisitContextRequestOptionsSchema.parse(contextOptions);
      const parameters = new URLSearchParams({ siteId });
      if (parsed.encounterId !== undefined) parameters.set("encounterId", parsed.encounterId);
      if (parsed.include !== undefined) parameters.set("include", parsed.include.join(","));
      if (parsed.minimumWatermark !== undefined) {
        parameters.set("minimumWatermark", String(parsed.minimumWatermark));
      }
      if (parsed.contextVersion !== undefined) {
        parameters.set("contextVersion", String(parsed.contextVersion));
      }
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(patientId)}/visit-context?${parameters.toString()}`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The patient visit context could not be loaded");
      }
      return VisitContextSchema.parse(unwrapRpcResult(await response.json()));
    },

    /**
     * Targeted-read escape hatch (plan Phase 8): the verbatim source a
     * condensed context references by provenance. Display-only — never
     * merged into the model context, which stays the stored version.
     */
    async readVisitSource(
      siteId: string,
      patientId: string,
      source: VisitSourceRef,
      signal?: AbortSignal,
    ) {
      const parsedSource = VisitSourceRefSchema.parse(source);
      const parameters = new URLSearchParams({
        siteId,
        sourceType: parsedSource.sourceType,
        sourceId: parsedSource.sourceId,
        version: String(parsedSource.version),
      });
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(patientId)}/visit-source?${parameters.toString()}`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The prior chart source could not be loaded");
      }
      return VisitSourceContentSchema.parse(unwrapRpcResult(await response.json()));
    },

    async recordPatientProblem(
      siteId: string,
      input: RecordPatientProblemInput,
      signal?: AbortSignal,
    ) {
      const parsed = RecordPatientProblemInputSchema.parse(input);
      return recordChartHistory("problems", siteId, parsed.patientId, parsed, signal);
    },

    async recordPatientMedication(
      siteId: string,
      input: RecordPatientMedicationInput,
      signal?: AbortSignal,
    ) {
      const parsed = RecordPatientMedicationInputSchema.parse(input);
      return recordChartHistory("medications", siteId, parsed.patientId, parsed, signal);
    },

    async recordPatientAllergy(
      siteId: string,
      input: RecordPatientAllergyInput,
      signal?: AbortSignal,
    ) {
      const parsed = RecordPatientAllergyInputSchema.parse(input);
      return recordChartHistory("allergies", siteId, parsed.patientId, parsed, signal);
    },

    async listPatientReferralArtifacts(patientId: string, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(patientId)}/referral-artifacts`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Prepared referral packages could not be loaded");
      }
      return z.array(PatientReferralArtifactSummarySchema).parse(await response.json());
    },

    /** The encounter's referral drafts still awaiting approval, newest first (REF-8). */
    async listEncounterReferralDrafts(encounterId: string, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/referral-drafts`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Referral drafts could not be loaded");
      }
      return z.array(EncounterReferralDraftSummarySchema).parse(await response.json());
    },

    /** The referrals the encounter's drafts became, newest first (EXECDEV-194). */
    async listEncounterReferrals(encounterId: string, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/referrals`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The encounter's referrals could not be loaded");
      }
      return z.array(EncounterReferralSummarySchema).parse(await response.json());
    },

    async listReferralEnclosureCandidates(patientId: string, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(patientId)}/referral-enclosure-candidates`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Chart documents could not be listed for enclosure");
      }
      return z.array(ReferralEnclosureCandidateSchema).parse(await response.json());
    },

    async downloadPreparedReferralPdf(
      referralId: string,
      signal?: AbortSignal,
      artifactId?: string,
    ) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/referrals/${encodeURIComponent(referralId)}/prepared-pdf${artifactId ? `?artifactId=${encodeURIComponent(artifactId)}` : ""}`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Prepared referral PDF could not be opened");
      }
      return response.blob();
    },

    async startPatientEncounter(
      patientId: string,
      input: StartPatientEncounterRequest,
      signal?: AbortSignal,
    ) {
      const body = StartPatientEncounterRequestSchema.parse(input);
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/patients/${encodeURIComponent(patientId)}/encounters`),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (response.status === 409) {
        throw new ClinicalWriteConflictError(
          "This start-visit key was already used with different details.",
        );
      }
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The visit could not be started");
      }
      const receipt = StartPatientEncounterResultSchema.parse(
        unwrapRpcResult(await response.json()),
      );
      if (receipt.patient.id !== patientId) {
        throw new Error("The started visit does not belong to the requested patient");
      }
      return receipt;
    },

    async createWalkIn(input: CreateWalkInRequest, signal?: AbortSignal) {
      const body = CreateWalkInRequestSchema.parse(input);
      const response = await request(sameOriginUrl(options.baseUrl, "/v1/patients/walk-in"), {
        method: "POST",
        headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
        body: JSON.stringify(body),
        cache: "no-store",
        credentials: "same-origin",
        ...(signal === undefined ? {} : { signal }),
      });
      if (response.status === 409) {
        throw new ClinicalWriteConflictError(
          "This walk-in intake key was already used with different details.",
        );
      }
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Walk-in registration could not be recorded");
      }
      return WalkInIntakeResultSchema.parse(unwrapRpcResult(await response.json()));
    },

    /**
     * Registers a patient without a visit (POST /v1/patients/register). 201 on
     * create, 200 on an idempotent replay; a 409 means the key was reused with
     * different details.
     */
    async registerPatient(input: RegisterPatientRequest, signal?: AbortSignal) {
      const body = RegisterPatientRequestSchema.parse(input);
      const response = await request(sameOriginUrl(options.baseUrl, "/v1/patients/register"), {
        method: "POST",
        headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
        body: JSON.stringify(body),
        cache: "no-store",
        credentials: "same-origin",
        ...(signal === undefined ? {} : { signal }),
      });
      if (response.status === 409) {
        throw new ClinicalWriteConflictError(
          "This registration key was already used with different details.",
        );
      }
      if (!response.ok) {
        throw blockedClinicalRequest(response, "Patient registration could not be recorded");
      }
      return RegisterPatientReceiptSchema.parse(unwrapRpcResult(await response.json()));
    },

    /**
     * Saves the chart entries a physician kept from another EMR's chart page onto
     * the patient they just registered (EXECDEV-227). A retry with the same key
     * resumes; one whose import already finished answers `alreadySaved`.
     */
    async importEmrPageChart(
      patientId: string,
      input: EmrPageChartImportRequest,
      signal?: AbortSignal,
    ) {
      const body = EmrPageChartImportRequestSchema.parse(input);
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(patientId)}/emr-page-import`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (response.status === 409) {
        throw new ClinicalWriteConflictError(
          "These chart entries were already being saved for another patient.",
        );
      }
      if (!response.ok) {
        throw (
          (await policyRefusal(response)) ??
          blockedClinicalRequest(response, "The imported chart entries could not be saved")
        );
      }
      const receipt = EmrPageChartImportReceiptSchema.parse(unwrapRpcResult(await response.json()));
      if (receipt.patientId !== patientId) {
        throw new Error("The chart import answered for another patient");
      }
      return receipt;
    },

    /** Whether this clinic offers registering patients from another EMR's chart page. */
    async getEmrPageImportSetting(siteId: string, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/emr-page-import/setting?siteId=${encodeURIComponent(siteId)}`,
        ),
        {
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The import setting could not be loaded");
      }
      return EmrPageImportSettingSchema.parse(await response.json());
    },

    /** A clinic administrator turning that import on or off, from the version they saw. */
    async setEmrPageImportSetting(siteId: string, enabled: boolean, expectedVersion: number) {
      const body = SetEmrPageImportSettingRequestSchema.parse({ siteId, enabled, expectedVersion });
      const response = await request(
        sameOriginUrl(options.baseUrl, "/v1/emr-page-import/setting"),
        {
          method: "PUT",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
        },
      );
      if (response.status === 409) {
        throw new ClinicalWriteConflictError(
          "Someone changed this setting a moment ago. Check it, then change it again.",
        );
      }
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The import setting could not be changed");
      }
      return EmrPageImportSettingSchema.parse(await response.json());
    },

    /** Soft duplicate probe before registering; nothing is blocked, the registrar decides. */
    async probeDuplicatePatients(
      siteId: string,
      probe: DuplicatePatientProbe,
      signal?: AbortSignal,
    ) {
      const body = DuplicatePatientProbeRequestSchema.parse({ siteId, probe });
      const response = await request(
        sameOriginUrl(options.baseUrl, "/v1/patients/duplicate-probe"),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The duplicate check could not be completed");
      }
      return DuplicatePatientMatchesSchema.parse(unwrapRpcResult(await response.json()));
    },

    async getPatientWorkspace(patientId: string, encounterId: string, signal?: AbortSignal) {
      if (options.siteId === undefined || options.siteId.length === 0) {
        throw new Error("A delegated clinic site is required to load the patient workspace");
      }
      const query = `siteId=${encodeURIComponent(options.siteId)}&encounterId=${encodeURIComponent(encounterId)}`;
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(patientId)}/workspace?${query}`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The patient workspace could not be loaded");
      }
      const workspace = PatientWorkspaceSchema.parse(
        unwrapRpcResult(await response.json(), "workspace"),
      );
      if (workspace.id !== patientId) {
        throw new Error("The patient workspace does not match the requested patient");
      }
      return workspace;
    },

    async saveEncounterNote(
      encounterId: string,
      input: EncounterNoteWriteRequest,
      signal?: AbortSignal,
    ) {
      const body = EncounterNoteWriteRequestSchema.parse(input);
      const response = await request(
        sameOriginUrl(options.baseUrl, `/v1/encounters/${encodeURIComponent(encounterId)}/note`),
        {
          method: "PUT",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (response.status === 409) {
        throw new ClinicalWriteConflictError(
          "The encounter note changed while you were editing. Reload and retry once.",
        );
      }
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The encounter note draft could not be saved");
      }
      return EncounterNoteWriteReceiptSchema.parse(unwrapRpcResult(await response.json(), "note"));
    },

    /** Short-lived server backup of an uninserted dictation; it expires 24 hours after its last save. */
    async saveDictationBackup(
      encounterId: string,
      input: SaveDictationBackupRequest,
      signal?: AbortSignal,
    ): Promise<DictationBackupReceipt> {
      const body = SaveDictationBackupRequestSchema.parse(input);
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/dictation-backup`,
        ),
        {
          method: "PUT",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The dictation backup could not be saved");
      }
      return z.object({ backup: DictationBackupReceiptSchema }).parse(await response.json()).backup;
    },

    async getDictationBackup(
      encounterId: string,
      signal?: AbortSignal,
    ): Promise<DictationBackup | null> {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/dictation-backup`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The dictation backup could not be read");
      }
      return z.object({ backup: DictationBackupSchema.nullable() }).parse(await response.json())
        .backup;
    },

    async deleteDictationBackup(encounterId: string, signal?: AbortSignal): Promise<void> {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/dictation-backup`,
        ),
        {
          method: "DELETE",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The dictation backup could not be deleted");
      }
      DictationBackupDeleteReceiptSchema.parse(await response.json());
    },

    /**
     * Saves the clinician's working draft of the visit note (one per clinician per visit). It
     * writes no note version and leaves the encounter version alone. `expectedRevision` names the
     * revision this save replaces (null for the first); another revision on the server is a
     * ClinicalWriteConflictError, a signed or cancelled visit a NoteWorkingDraftClosedError.
     * `keepalive` lets the request outlive the page when the body fits the browser's limit.
     */
    async saveNoteWorkingDraft(
      encounterId: string,
      input: SaveNoteWorkingDraftRequest,
      requestOptions?: { readonly signal?: AbortSignal; readonly keepalive?: boolean },
    ): Promise<NoteWorkingDraftReceipt> {
      const body = JSON.stringify(SaveNoteWorkingDraftRequestSchema.parse(input));
      const keepalive =
        requestOptions?.keepalive === true &&
        new TextEncoder().encode(body).byteLength < NOTE_WORKING_DRAFT_KEEPALIVE_MAX_BYTES;
      const signal = requestOptions?.signal;
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/note-working-draft`,
        ),
        {
          method: "PUT",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body,
          cache: "no-store",
          credentials: "same-origin",
          ...(keepalive ? { keepalive: true } : {}),
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw await noteWorkingDraftRefusal(
          response,
          "This note was saved from another tab or device. Review both versions before saving again.",
          "The note draft could not be saved",
        );
      }
      const draft = z
        .object({ draft: NoteWorkingDraftReceiptSchema })
        .parse(await response.json()).draft;
      if (draft.encounterId !== encounterId) {
        throw new Error("The note draft receipt does not match the encounter");
      }
      return draft;
    },

    /** The addenda to an encounter's signed note, oldest first. */
    async listEncounterNoteAddenda(
      encounterId: string,
      signal?: AbortSignal,
    ): Promise<EncounterNoteAddenda> {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/note-addenda`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The addenda could not be loaded");
      }
      const addenda = EncounterNoteAddendaSchema.parse(await response.json());
      if (
        addenda.encounterId !== encounterId ||
        addenda.items.some((item) => item.encounterId !== encounterId)
      ) {
        throw new Error("The addenda do not match the encounter");
      }
      return addenda;
    },

    /**
     * Signs an addendum to the visit's signed note as the signed-in physician. Reusing the key
     * after a lost response answers with the addendum already signed (`created` false) and
     * never signs twice; other text under that key is a ClinicalWriteConflictError.
     */
    async signEncounterNoteAddendum(
      encounterId: string,
      input: SignEncounterNoteAddendumRequest,
    ): Promise<SignEncounterNoteAddendumReceipt> {
      const body = JSON.stringify(SignEncounterNoteAddendumRequestSchema.parse(input));
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/note-addenda`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body,
          cache: "no-store",
          credentials: "same-origin",
        },
      );
      if (!response.ok) throw await noteAddendumRefusal(response);
      const receipt = SignEncounterNoteAddendumReceiptSchema.parse(await response.json());
      if (receipt.addendum.encounterId !== encounterId) {
        throw new Error("The addendum receipt does not match the encounter");
      }
      return receipt;
    },

    /** The clinician's own working draft of the visit note, or null when there is none. */
    async getNoteWorkingDraft(
      encounterId: string,
      signal?: AbortSignal,
    ): Promise<NoteWorkingDraft | null> {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/note-working-draft`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The note draft could not be loaded");
      }
      const draft = z
        .object({ draft: NoteWorkingDraftSchema.nullable() })
        .parse(await response.json()).draft;
      if (draft !== null && draft.encounterId !== encounterId) {
        throw new Error("The note draft does not match the encounter");
      }
      return draft;
    },

    /**
     * Deletes the clinician's working draft. With `revision`, only that revision is deleted: a
     * draft saved since from another tab or device is kept (ClinicalWriteConflictError).
     */
    async deleteNoteWorkingDraft(
      encounterId: string,
      requestOptions?: { readonly revision?: number; readonly signal?: AbortSignal },
    ): Promise<NoteWorkingDraftDeleteReceipt> {
      const revision = z.number().int().positive().optional().parse(requestOptions?.revision);
      const signal = requestOptions?.signal;
      const query = revision === undefined ? "" : `?revision=${revision}`;
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/note-working-draft${query}`,
        ),
        {
          method: "DELETE",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw await noteWorkingDraftRefusal(
          response,
          "This note draft was saved again from another tab or device, so it was kept.",
          "The note draft could not be deleted",
        );
      }
      const receipt = NoteWorkingDraftDeleteReceiptSchema.parse(await response.json());
      if (receipt.encounterId !== encounterId) {
        throw new Error("The note draft receipt does not match the encounter");
      }
      return receipt;
    },

    /**
     * Replace-set write of the coded diagnoses on an open encounter, keyed by
     * `expectedEncounterVersion`. A 409 means the encounter moved (stale
     * version) or the note is already signed and the set is frozen.
     */
    async saveEncounterDiagnoses(
      encounterId: string,
      input: SaveEncounterDiagnosesRequest,
      signal?: AbortSignal,
    ) {
      const body = SaveEncounterDiagnosesRequestSchema.parse(input);
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/diagnoses`,
        ),
        {
          method: "PUT",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (response.status === 409) {
        throw new ClinicalWriteConflictError(
          "The encounter changed while you were editing its diagnoses. Reload and retry once.",
        );
      }
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The encounter diagnoses could not be saved");
      }
      return SaveEncounterDiagnosesReceiptSchema.parse(unwrapRpcResult(await response.json()));
    },

    async signEncounterNote(
      encounterId: string,
      input: EncounterNoteWriteRequest,
      signal?: AbortSignal,
    ) {
      const body = EncounterNoteWriteRequestSchema.parse(input);
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/note/sign`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (response.status === 409) {
        throw new ClinicalWriteConflictError(
          "The exact draft changed before signing. Reload the latest note and review again.",
        );
      }
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The encounter note could not be signed");
      }
      return EncounterNoteWriteReceiptSchema.parse(unwrapRpcResult(await response.json(), "note"));
    },

    async getWorkforceProfile(signal?: AbortSignal) {
      const response = await request(sameOriginUrl(options.baseUrl, "/v1/workforce/profile"), {
        method: "GET",
        headers: await authorizedHeaders(),
        cache: "no-store",
        credentials: "same-origin",
        ...(signal === undefined ? {} : { signal }),
      });
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The workforce profile could not be loaded");
      }
      return WorkforceProfileSchema.parse(unwrapRpcResult(await response.json(), "profile"));
    },

    async updateWorkforceProfile(input: UpdateWorkforceProfileRequest, signal?: AbortSignal) {
      const body = UpdateWorkforceProfileRequestSchema.parse(input);
      const response = await request(sameOriginUrl(options.baseUrl, "/v1/workforce/profile"), {
        method: "PUT",
        headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
        body: JSON.stringify(body),
        cache: "no-store",
        credentials: "same-origin",
        ...(signal === undefined ? {} : { signal }),
      });
      if (response.status === 409) {
        throw new ClinicalWriteConflictError(
          "The workforce profile changed elsewhere. Reload the profile and retry once.",
        );
      }
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The workforce profile could not be updated");
      }
      return WorkforceProfileSchema.parse(unwrapRpcResult(await response.json(), "profile"));
    },

    async getSiteContact(signal?: AbortSignal) {
      const response = await request(sameOriginUrl(options.baseUrl, "/v1/site/contact"), {
        method: "GET",
        headers: await authorizedHeaders(),
        cache: "no-store",
        credentials: "same-origin",
        ...(signal === undefined ? {} : { signal }),
      });
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The clinic contact details could not be loaded");
      }
      return SiteContactSchema.parse(unwrapRpcResult(await response.json(), "siteContact"));
    },

    async updateSiteContact(input: UpdateSiteContactRequest, signal?: AbortSignal) {
      const body = UpdateSiteContactRequestSchema.parse(input);
      const response = await request(sameOriginUrl(options.baseUrl, "/v1/site/contact"), {
        method: "PUT",
        headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
        body: JSON.stringify(body),
        cache: "no-store",
        credentials: "same-origin",
        ...(signal === undefined ? {} : { signal }),
      });
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The clinic contact details could not be updated");
      }
      return SiteContactSchema.parse(unwrapRpcResult(await response.json(), "siteContact"));
    },

    async listWorkforceMembers(signal?: AbortSignal) {
      const response = await request(sameOriginUrl(options.baseUrl, "/v1/workforce/members"), {
        method: "GET",
        headers: await authorizedHeaders(),
        cache: "no-store",
        credentials: "same-origin",
        ...(signal === undefined ? {} : { signal }),
      });
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The workforce members could not be loaded");
      }
      return z
        .array(WorkforceMemberSchema)
        .parse(unwrapRpcResult(await response.json(), "members"));
    },

    async listWorkforceInvitations(signal?: AbortSignal) {
      const response = await request(sameOriginUrl(options.baseUrl, "/v1/workforce/invitations"), {
        method: "GET",
        headers: await authorizedHeaders(),
        cache: "no-store",
        credentials: "same-origin",
        ...(signal === undefined ? {} : { signal }),
      });
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The workforce invitations could not be loaded");
      }
      return z
        .array(WorkforceInvitationSchema)
        .parse(unwrapRpcResult(await response.json(), "invitations"));
    },

    async createWorkforceInvitation(input: CreateWorkforceInvitationRequest, signal?: AbortSignal) {
      const body = CreateWorkforceInvitationRequestSchema.parse(input);
      if (options.siteId !== undefined && body.siteId !== options.siteId) {
        throw new Error("The workforce invitation must target the delegated clinic site");
      }
      const response = await request(sameOriginUrl(options.baseUrl, "/v1/workforce/invitations"), {
        method: "POST",
        headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
        body: JSON.stringify(body),
        cache: "no-store",
        credentials: "same-origin",
        ...(signal === undefined ? {} : { signal }),
      });
      if (response.status === 409) {
        throw new ClinicalWriteConflictError(
          "That invitation idempotency key was already used for a different request.",
        );
      }
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The workforce invitation could not be created");
      }
      return WorkforceInvitationOutcomeSchema.parse(await response.json());
    },

    async revokeWorkforceInvitation(invitationId: string, signal?: AbortSignal) {
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/workforce/invitations/${encodeURIComponent(invitationId)}/revoke`,
        ),
        {
          method: "POST",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The workforce invitation could not be revoked");
      }
      return WorkforceInvitationSchema.parse(unwrapRpcResult(await response.json(), "invitation"));
    },

    async setWorkforceMembershipStatus(
      userId: string,
      input: { siteId: string; active: boolean; reasonCode: string },
      signal?: AbortSignal,
    ) {
      if (options.siteId !== undefined && input.siteId !== options.siteId) {
        throw new Error("The membership change must target the delegated clinic site");
      }
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/workforce/members/${encodeURIComponent(userId)}/status`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(input),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The membership status could not be changed");
      }
      return WorkforceMembershipStatusOutcomeSchema.parse(await response.json());
    },

    async createPrintablePrescription(
      encounterId: string,
      input: PrintablePrescriptionRequest,
      signal?: AbortSignal,
    ) {
      const body = PrintablePrescriptionRequestSchema.parse(input);
      if (options.siteId !== undefined && body.siteId !== options.siteId) {
        throw new Error("The printable prescription must target the delegated clinic site");
      }
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/printable-prescriptions`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The printable prescription could not be signed");
      }
      const prescription = PrintablePrescriptionRecordSchema.parse(
        unwrapRpcResult(await response.json(), "prescription"),
      );
      if (prescription.verification !== "verified") {
        throw new Error("Could not verify the signed prescription PDF.");
      }
      return prescription;
    },

    /**
     * The active chart medications a physician can refill, each with the
     * latest prescription item signed at this site that lists it (EXECDEV-101).
     */
    async listMedicationRefillCandidates(siteId: string, patientId: string, signal?: AbortSignal) {
      const parameters = new URLSearchParams({ siteId: z.string().uuid().parse(siteId) });
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(z.string().uuid().parse(patientId))}/medication-refills?${parameters.toString()}`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The medications to refill could not be loaded");
      }
      const candidates = MedicationRefillCandidatesSchema.parse(await response.json());
      if (candidates.patientId !== patientId) {
        throw new Error("The medications to refill belong to another patient.");
      }
      return candidates;
    },

    /** Screens a refill against the patient's chart outside a visit (EXECDEV-101). */
    async screenPatientFdbPrescription(
      siteId: string,
      input: FdbScreeningRequest,
      signal?: AbortSignal,
    ) {
      const body = FdbScreeningRequestSchema.parse(input);
      const parameters = new URLSearchParams({ siteId: z.string().uuid().parse(siteId) });
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(body.patientId)}/prescription-screenings?${parameters.toString()}`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The prescription could not be screened");
      }
      return FdbScreeningSchema.parse(await response.json());
    },

    /**
     * Signs a refill outside a visit (EXECDEV-101): the server opens a
     * "Prescription renewal" encounter, signs this prescription and a one-line
     * note on it, and closes it. A retry with the same idempotency key answers
     * with the renewal already signed.
     */
    async signPrescriptionRenewal(input: PrintablePrescriptionRequest, signal?: AbortSignal) {
      const body = PrintablePrescriptionRequestSchema.parse(input);
      if (options.siteId !== undefined && body.siteId !== options.siteId) {
        throw new Error("The prescription renewal must target the delegated clinic site");
      }
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(body.patient.patientId)}/prescription-renewals`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The refill could not be signed");
      }
      const receipt = PrescriptionRenewalReceiptSchema.parse(await response.json());
      if (receipt.prescription.verification !== "verified") {
        throw new Error("Could not verify the signed prescription PDF.");
      }
      return receipt;
    },

    /**
     * Signs a change outside a visit (EXECDEV-176): the server opens a
     * "Prescription change" encounter, signs this change and a one-line note on
     * it, and closes it. A retry with the same idempotency key answers with the
     * change already signed.
     */
    async signPrescriptionChange(input: PrintablePrescriptionRequest, signal?: AbortSignal) {
      const body = PrintablePrescriptionRequestSchema.parse(input);
      if (options.siteId !== undefined && body.siteId !== options.siteId) {
        throw new Error("The prescription change must target the delegated clinic site");
      }
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(body.patient.patientId)}/prescription-changes`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The change could not be signed");
      }
      const receipt = PrescriptionChangeReceiptSchema.parse(await response.json());
      if (receipt.prescription.verification !== "verified") {
        throw new Error("Could not verify the signed prescription PDF.");
      }
      return receipt;
    },

    /**
     * Cancels medications of a signed printable prescription (EXECDEV-176),
     * inside a visit when the request names one. A retry with the same
     * idempotency key answers with what it already cancelled.
     */
    async cancelPrintablePrescription(
      input: CancelPrintablePrescriptionRequest,
      signal?: AbortSignal,
    ) {
      const body = CancelPrintablePrescriptionRequestSchema.parse(input);
      if (options.siteId !== undefined && body.siteId !== options.siteId) {
        throw new Error("The prescription cancellation must target the delegated clinic site");
      }
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/patients/${encodeURIComponent(body.patientId)}/prescription-cancellations`,
        ),
        {
          method: "POST",
          headers: { ...(await authorizedHeaders()), "content-type": "application/json" },
          body: JSON.stringify(body),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(response, "The prescription could not be cancelled");
      }
      const receipt = PrintablePrescriptionCancellationSchema.parse(await response.json());
      if (
        receipt.patientId !== body.patientId ||
        receipt.printablePrescriptionId !== body.printablePrescriptionId
      ) {
        throw new Error("The cancellation answered for another prescription.");
      }
      return receipt;
    },

    /**
     * Every prescription already signed on this encounter, with its stored PDF,
     * so a resumed visit can reprint exactly what it issued.
     */
    async listPrintablePrescriptions(encounterId: string, signal?: AbortSignal) {
      if (options.siteId === undefined || options.siteId.length === 0) {
        throw new Error("A delegated clinic site is required to list printable prescriptions");
      }
      const response = await request(
        sameOriginUrl(
          options.baseUrl,
          `/v1/encounters/${encodeURIComponent(encounterId)}/printable-prescriptions?siteId=${encodeURIComponent(options.siteId)}`,
        ),
        {
          method: "GET",
          headers: await authorizedHeaders(),
          cache: "no-store",
          credentials: "same-origin",
          ...(signal === undefined ? {} : { signal }),
        },
      );
      if (!response.ok) {
        throw blockedClinicalRequest(
          response,
          "The signed prescriptions for this encounter could not be loaded",
        );
      }
      const prescriptions = PrintablePrescriptionListSchema.parse(
        unwrapRpcResult(await response.json(), "prescriptions"),
      );
      if (prescriptions.some((prescription) => prescription.encounterId !== encounterId)) {
        throw new Error("The signed prescriptions do not match the requested encounter");
      }
      return prescriptions.map((prescription) =>
        prescription.verification === "verified"
          ? prescription
          : { ...prescription, verification: "failed" as const, documentBase64: "" },
      );
    },
  };
}
